import dayjs from "dayjs";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import ImageViewer from "react-simple-image-viewer";
import uuid from "react-uuid";
import toastr from "toastr";
import roomBunkImg from "../../assets/images/bunk.svg";
import check from "../../assets/images/check.svg";
import foodPic from "../../assets/images/food.svg";
import kidPic from "../../assets/images/kid.svg";
import minus from "../../assets/images/minus.svg";
import plus from "../../assets/images/plus.svg";
import userpic from "../../assets/images/user.svg";
import CircleLoader from "../../components/CircleLoader/CircleLoader";
import Drawer from "../../components/Drawer/Drawer";
import Icon from "../../components/Icon/Icon";
import viewIcon from "../../assets/svg/view icon (3).svg";
import {
  addAddon,
  addRatePlan,
  addRoom,
  available,
  deselectAddon,
  deselectRoom,
} from "../../redux/actions/hotelInfoAction";
import hotelInfoTypes from "../../redux/actionType/hotelInfoTypes";
import storageService from "../../Services/storageService";
import { currency as currencies, currency } from "../../utils/currency";
import { fireGtmEvent, pixelHighIntent } from "../../utils/googleAnalytics";
import { RoomAmenityIcons } from "../../utils/icons";
import {
  arrangePromos,
  calculatePromotion,
  getApplicablePromotion,
  getApplicablePromotionRoom,
} from "../../utils/usePriceCalculator";
import useWindowSize from "../../utils/useWindowSize";
import {
  convert24hrTo12hr,
  EXCLUDE_DISCOUNT_ROOM,
  getCalculatedTax,
  getFixedValue,
  IMAGE_QUALITY,
  isStartTimeBeforeEndTime,
  mmtColorHotels,
  pluralWords,
  sourceTest,
} from "../../utils/utils";
import isBetween from "dayjs/plugin/isBetween";
import { isRoomAvailableApi } from "../../Services/mainPageService";
import CancellationPolicy from "../../components/CancellationPolicy/CancellationPolicy";
import unlockSVG from "../../assets/svg/unlock_svg.svg";
import MembershipDealsModal from "../../components/Modals/MembershipDealsModal/MembershipDealsModal.jsx";
import SecretMemberDeal from "./SecretMemberDeal/SecretMemberDeal.jsx";
import rp_inclusion_icon from "../../assets/svg/rp_inclusion_icon.svg";
import RatePlanModal from "../../components/Modals/RatePlanModal/RatePlanModal.jsx";
import { MdNotificationsActive } from "react-icons/md";
import InventoryRetargModal from "../../components/Modals/InventoryRetargetting/InventoryRetargModal.jsx";
import { getTextKey, shouldUseHotelType } from "../../utils/textConfig.js";
dayjs.extend(isBetween);

const Button = ({ value, setValue, maxValue, room, price, isHourlyRoom }) => {
  const dispatch = useDispatch();
  const {
    RoomImages,
    maxGuestCount,
    defaultGuestCount,
    defaultPrice,
    availableRooms,
  } = room;
  const {
    promotions,
    roomSlots = {},
    hourlyTime,
    selectedRooms,
    hotelData,
  } = useSelector((state) => state.hotelInfo);

  let promo = promotions?.sort((a, b) => b.discount - a.discount)[0];

  if (promo?.type === "bulk" && !isHourlyRoom) {
    promo = null;
    if (promotions?.length > 1) {
      promo = promotions[1];
    }
  }

  const { t } = useTranslation();

  const increment = () => {
    if (value < maxValue) {
      let arr = Object.keys(roomSlots).length > 0 ? Object.keys(roomSlots) : [];
      if (
        isHourlyRoom &&
        arr?.length > 0 &&
        arr.includes(String(room?.id)) &&
        Object.keys(roomSlots[room?.id]).length > 0
      ) {
        let newAr = arr.filter((ar) => ar === String(room?.id));
        let isDisable = !(
          isStartTimeBeforeEndTime(
            convert24hrTo12hr(roomSlots[room?.id]?.firstCheckInTime),
            hourlyTime
          ) &&
          isStartTimeBeforeEndTime(
            hourlyTime,
            convert24hrTo12hr(roomSlots[room?.id]?.lastCheckInTime)
          )
        );
        if (isDisable) {
          toastr.error(t("not_available_selected_checkin_time"));
          return;
        }
      }
      if (isHourlyRoom && !Object.keys(roomSlots).includes(String(room?.id))) {
        toastr.error(t("please_select_time_slot"));
        return;
      }

      setValue((val) => val + 1);
      dispatch(addRoom(room));

      fireGtmEvent("room_added", {
        room_name: room?.roomName,
        roomId: room?.id,
        totalPrice: price,
        pricePerNight: parseInt(defaultPrice),
        photos: RoomImages?.length,
        defaultGuestCount,
        maxGuestCount,
        oneRoomLeft: availableRooms < 3,
        availableRooms,
      });
      if (hotelData?.userId === 103376 && window && window?.gtag) {
        window?.gtag("event", "add_to_cart", {
          value: price,
          currency: hotelData?.currency,
          items: [
            {
              price: price, // Room price per night
              item_id: hotelData?.id, // Room ID or SKU
              item_name: room?.roomName, // Room name
            },
          ],
        });
      }
    }
  };

  const decrement = () => {
    if (value > 0) {
      setValue((val) => val - 1);
      dispatch(deselectRoom(room));

      fireGtmEvent("room_removed", {
        roomName: room?.roomName,
        roomId: room?.id,
        totalPrice: price,
        pricePerNight: parseInt(defaultPrice),
        photos: RoomImages?.length,
        defaultGuestCount,
        maxGuestCount,
        oneRoomLeft: availableRooms < 3,
        availableRooms,
      });
      if (hotelData?.userId === 103376 && window && window?.gtag) {
        window?.gtag("event", "remove_from_cart", {
          value: price,
          currency: hotelData?.currency,
          items: [
            {
              price: price, // Room price per night
              item_id: hotelData?.id, // Room ID or SKU
              item_name: room?.roomName, // Room name
            },
          ],
        });
      }
    }
  };
  return value > 0 ? (
    <div className="hAddonAdded">
      <img
        src={minus}
        alt="remove room"
        className="hAddonIcon"
        onClick={decrement}
      />

      <span>{value}</span>
      <img
        src={plus}
        alt="add room"
        className="hAddonIcon"
        onClick={increment}
      />
    </div>
  ) : (
    (!isHourlyRoom || selectedRooms?.length > 0) && (
      <div onClick={increment} className="hAddonAdd btnShadow">
        <b
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {" "}
          {t("reserve")}{" "}
          {isHourlyRoom && (
            <img
              src="https://ik.imagekit.io/hotelzifyprod/f4ce4893-c0f4-4475-866b-c5dc54c7c760.svg"
              width={20}
              height={20}
              alt=""
            />
          )}{" "}
        </b>{" "}
      </div>
    )
  );
};

const AddonButton = ({
  name,
  extraChild,
  setExtraChild,
  extraAdult,
  setExtraAdult,
  maxGuestCount,
  addon,
  setPeople,
  defaultGuestCount,
  totalPeople,
  guestToDisplay,
  room,
  roomCount,
  extraInfant,
  setExtraInfant,
  adultAddons,
}) => {
  const dispatch = useDispatch();

  const { selectedAddons } = useSelector((state) => state.hotelInfo);
  const { t } = useTranslation();

  const increment = () => {
    let guestCount = selectedAddons?.filter(
      (adn) =>
        adn?.hotel_room_id === room?.id && adn?.Addon?.category === "person"
    )?.length;
    if (
      extraChild + extraAdult + extraInfant <
        (maxGuestCount - defaultGuestCount) * roomCount &&
      name?.startsWith("Extra") &&
      guestCount + defaultGuestCount < maxGuestCount * roomCount
    ) {
      name === "Extra Adult"
        ? dispatch(addAddon(adultAddons[extraAdult]))
        : dispatch(addAddon(addon));
      name === "Extra Adult"
        ? setExtraAdult((state) => state + 1)
        : name === "Extra Child" && addon?.type === "infant"
        ? setExtraInfant((prev) => prev + 1)
        : setExtraChild((state) => state + 1);
      setPeople((state) => state + 1);
      fireGtmEvent("addon_selected", {
        addon_name: addon?.Addon?.name,
        addon_price: addon?.price,
        addon_id: addon?.id,
        hotel_room_id: addon?.hotel_room_id,
      });
    } else {
      toastr.error(t("maximum_occupancy_reached"));
    }
  };

  const decrement = () => {
    if (name === "Extra Adult" && extraAdult > 0) {
      dispatch(deselectAddon(adultAddons[extraAdult - 1]));
      setExtraAdult((state) => state - 1);
      setPeople((state) => state - 1);

      fireGtmEvent("addon_removed", {
        addonName: addon?.Addon?.name,
        addonPrice: addon?.price,
        addonId: addon?.id,
        hotelRoomId: addon?.hotel_room_id,
      });
    } else if (
      name === "Extra Child" &&
      extraChild > 0 &&
      addon?.type === "child"
    ) {
      dispatch(deselectAddon(addon));
      setExtraChild((state) => state - 1);
      setPeople((state) => state - 1);
      fireGtmEvent("addon_removed", {
        addonName: addon?.Addon?.name,
        addonPrice: addon?.price,
        addonId: addon?.id,
        hotelRoomId: addon?.hotel_room_id,
      });
    } else if (
      name === "Extra Child" &&
      extraInfant > 0 &&
      addon?.type === "infant"
    ) {
      dispatch(deselectAddon(addon));
      setExtraInfant((prev) => prev - 1);
      setPeople((state) => state - 1);
      fireGtmEvent("addon_removed", {
        addonName: addon?.Addon?.name,
        addonPrice: addon?.price,
        addonId: addon?.id,
        hotelRoomId: addon?.hotel_room_id,
      });
    }
  };
  return (
    <div className="incrementer roomCom">
      <div onClick={decrement} className="decrement roomInc">
        -
      </div>
      <div className="incrementer__value roomVal">
        {name === "Extra Adult"
          ? extraAdult
          : addon?.type === "infant"
          ? extraInfant
          : extraChild}
      </div>

      <div onClick={increment} className="increment roomInc">
        +
      </div>
    </div>
  );
};

const MealAddon = ({
  addon,
  name,
  addAddon,
  deselectAddon,
  room,
  breakfast,
  lunch,
  dinner,
  setBreakfast,
  setLunch,
  setDinner,
  maxGuestCount,
}) => {
  const dispatch = useDispatch();

  const increment = () => {
    if (name === "Breakfast" && breakfast < maxGuestCount) {
      setBreakfast((prev) => prev + 1);
      dispatch(addAddon(addon));
    }
    if (name === "Lunch" && lunch < maxGuestCount) {
      setLunch((prev) => prev + 1);
      dispatch(addAddon(addon));
    }
    if (name === "Dinner" && dinner < maxGuestCount) {
      setDinner((prev) => prev + 1);
      dispatch(addAddon(addon));
    }
  };

  const decrement = () => {
    if (name === "Breakfast" && breakfast > 0) {
      setBreakfast((prev) => prev - 1);
      dispatch(deselectAddon(addon));
    }
    if (name === "Lunch" && lunch > 0) {
      setLunch((prev) => prev - 1);
      dispatch(deselectAddon(addon));
    }
    if (name === "Dinner" && dinner > 0) {
      setDinner((prev) => prev - 1);
      dispatch(deselectAddon(addon));
    }
  };

  return (
    <div className="incrementer roomCom">
      <div onClick={decrement} className="decrement roomInc">
        -
      </div>
      <div className="incrementer__value roomVal">
        {addon?.Addon?.name === "Breakfast"
          ? breakfast
          : addon?.Addon?.name === "Lunch"
          ? lunch
          : dinner}
      </div>

      <div onClick={increment} className="increment roomInc">
        +
      </div>
    </div>
  );
};

const NewSelectionSlot = ({
  id,
  defaultGuestCount,
  maxGuestCount,
  extraInfantPrice,
  extraChildPrice,
  room,
  childAgeSplit,
  childAgeLimit,
}) => {
  const { selectedRooms, isRatePlans } = useSelector(
    (state) => state.hotelInfo
  );

  const dispatch = useDispatch();

  const [selectedAdultCount, setSelectedAdultCount] =
    useState(defaultGuestCount);
  const [selectedChildCount, setSelectedChildCount] = useState(0);
  const [selectedInfantCount, setSelectedInfantCount] = useState(0);
  const [thisRoom, setThisRoom] = useState();
  const [isSetRoom, setIsSetRoom] = useState(true);
  const [isRoomDescOpen, setRoomDescOpen] = useState(false);

  useEffect(() => {
    if (selectedRooms?.length > 0) {
      let rom =
        selectedRooms?.filter(
          (rm) => rm?.id === room?.id && Number(rm?.idx) === Number(id)
        )[0] || {};

      setThisRoom(rom);
    }
  }, [selectedRooms]);

  useEffect(() => {
    if (thisRoom) {
      setSelectedAdultCount(thisRoom?.sAdult);
      setSelectedChildCount(thisRoom?.sChild);
      setSelectedInfantCount(thisRoom?.sInfant);
      setIsSetRoom(false);
    } else {
      setIsSetRoom(true);
    }
  }, [thisRoom]);

  useEffect(() => {
    let rom =
      selectedRooms?.filter(
        (rm) => rm?.id === room?.id && Number(rm?.idx) === Number(id)
      )[0] || {};
    if (selectedRooms?.length > 0 && rom && !isSetRoom) {
      rom = {
        ...rom,
        sAdult: selectedAdultCount,
        sChild: selectedChildCount,
        sInfant: selectedInfantCount,
      };
      dispatch({ type: hotelInfoTypes.SET_ROOM, payload: rom });
    }
  }, [selectedAdultCount, selectedChildCount, selectedInfantCount]);

  const { width } = useWindowSize();

  const { t } = useTranslation();

  return (
    <div
      className="newSelectionType"
      style={{ padding: isRatePlans && "10px 0" }}
    >
      <div className="newSelectionRoom">
        <p>
          {t("room")} {id}
        </p>
      </div>
      <div className="newSelections">
        <div
          className="newSelection"
          style={{ alignItems: width > 901 && "center" }}
        >
          {/* <p>
            {t("adults")}:{" "}
            {width < 901 && (
              <span style={{ color: "#fff" }}> {t("adult_age")}</span>
            )}
          </p> */}
          <p
            style={{
              color:
                maxGuestCount - selectedAdultCount - selectedInfantCount ===
                  0 && "#dadada",
            }}
          >
            {t("adults")}:{" "}
            <span>
              {"Above "}
              {childAgeLimit}
              {t("years")}
            </span>{" "}
          </p>

          <select
            value={selectedAdultCount}
            className="selectorDrop"
            onChange={(e) => {
              setSelectedAdultCount(Number(e.target.value));
              fireGtmEvent("adult_dropdown_clicked", {
                count: e.target.value,
                roomIndex: id,
                room,
              });
            }}
          >
            {Array.from({
              length: maxGuestCount - selectedChildCount - selectedInfantCount,
            }).map((_, idx) => {
              return (
                <option value={idx + 1} key={uuid()}>
                  {idx + 1}
                </option>
              );
            })}
          </select>
        </div>
        {extraChildPrice && (
          <div className="newSelection">
            <p
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedInfantCount ===
                    0 && "#dadada",
              }}
            >
              {t("children")}:{" "}
              <span>
                ({childAgeSplit}
                {t("years")} - {childAgeLimit}
                {t("years")})
              </span>{" "}
            </p>
            <select
              className="selectorDrop"
              value={selectedChildCount}
              disabled={
                maxGuestCount - selectedAdultCount - selectedInfantCount === 0
              }
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedInfantCount ===
                    0 && "#dadada",
              }}
              onChange={(e) => {
                setSelectedChildCount(Number(e.target.value));
                fireGtmEvent("child_dropdown_clicked", {
                  count: e.target.value,
                  roomIndex: id,
                  room,
                });
              }}
            >
              {/* <option value={0}>Select</option> */}
              {Array.from({
                length:
                  maxGuestCount - selectedAdultCount - selectedInfantCount + 1,
              }).map((_, idx) => {
                return (
                  <option key={uuid()} value={idx}>
                    {idx === 0 ? "Select" : idx}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {extraInfantPrice && (
          <div className="newSelection">
            <p
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedChildCount ===
                    0 && "#dadada",
              }}
            >
              {t("infants")}:
              <span>
                (0 - {childAgeSplit - 1}
                {t("years")})
              </span>{" "}
            </p>
            <select
              className="selectorDrop"
              value={selectedInfantCount}
              disabled={
                maxGuestCount - selectedAdultCount - selectedChildCount === 0
              }
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedChildCount ===
                    0 && "#dadada",
              }}
              onChange={(e) => {
                setSelectedInfantCount(Number(e.target.value));
                fireGtmEvent("infant_dropdown_clicked", {
                  count: e.target.value,
                  roomIndex: id,
                  room,
                });
              }}
            >
              {Array.from({
                length:
                  maxGuestCount - selectedAdultCount - selectedChildCount + 1,
              }).map((_, idx) => {
                return (
                  <option key={uuid()} value={idx}>
                    {idx === 0 ? "Select" : idx}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

const RateplanSlot = ({
  id,
  thisPlan,
  maxAdultCount,
  maxGuestCount,
  extraChildPrice,
  extraInfantPrice,
  room,
  childAgeSplit,
  childAgeLimit,
}) => {
  const { selectedRooms, isRatePlans } = useSelector(
    (state) => state.hotelInfo
  );

  const { maxChildCount, maxInfantCount } = room;
  const dispatch = useDispatch();

  const [selectedAdultCount, setSelectedAdultCount] = useState(0);
  const [selectedChildCount, setSelectedChildCount] = useState(0);
  const [selectedInfantCount, setSelectedInfantCount] = useState(0);
  const [thisRoom, setThisRoom] = useState();
  const [isSetRoom, setIsSetRoom] = useState(true);

  useEffect(() => {
    if (thisPlan) {
      setSelectedAdultCount(thisPlan?.sAdult);
      setSelectedChildCount(thisPlan?.sChild);
      setSelectedInfantCount(thisPlan?.sInfant);
      setIsSetRoom(false);
    } else {
      setIsSetRoom(true);
    }
  }, [thisPlan]);

  useEffect(() => {
    let rom =
      selectedRooms?.filter(
        (rm) => rm?.id === room?.id && Number(rm?.idx) === Number(id)
      )[0] || {};
    if (selectedRooms?.length > 0 && rom && !isSetRoom) {
      rom = {
        ...rom,
        sAdult: selectedAdultCount,
        sChild: selectedChildCount,
        sInfant: selectedInfantCount,
      };
      dispatch({ type: hotelInfoTypes.SET_ROOM, payload: rom });
    }
  }, [selectedAdultCount, selectedChildCount, selectedInfantCount]);

  const { width } = useWindowSize();

  const { t } = useTranslation();

  const handleChange = (e) => {
    let cnt = Number(e.target.value);
    let name = e.target.name;
    let obj = { ...thisPlan, [name]: cnt };
    dispatch({ type: hotelInfoTypes.EDIT_RP, payload: obj });
  };

  return (
    <div
      className="newSelectionType"
      style={{
        padding: isRatePlans && "10px 0",
        borderTop: isRatePlans && "none",
      }}
    >
      <div className="newSelectionRoom">
        <p>
          {t("room")} {id}
        </p>
      </div>
      <div className="newSelections">
        <div
          className="newSelection"
          style={{ alignItems: width > 901 && "center" }}
        >
          {/* <p>
            {t("adults")}:{" "}
            {width < 901 && (
              <span style={{ color: "#fff" }}> {t("adult_age")}</span>
            )}
          </p> */}

          <p
          // style={{
          //   color:
          //      "#fff",
          // }}
          >
            {t("adults")}:{" "}
            <span>
              {"Above "}
              {childAgeLimit}
              {t("years")}
            </span>{" "}
          </p>

          <select
            value={selectedAdultCount}
            className="selectorDrop"
            name="sAdult"
            onChange={(e) => {
              setSelectedAdultCount(Number(e.target.value));
              fireGtmEvent("adult_dropdown_clicked", {
                count: e.target.value,
                roomIndex: id,
                room,
              });
              handleChange(e);
            }}
          >
            {Array.from({
              length:
                maxGuestCount - selectedInfantCount - selectedChildCount >
                maxAdultCount
                  ? maxAdultCount
                  : maxGuestCount - selectedInfantCount - selectedChildCount,
            }).map((_, idx) => {
              return (
                <option value={idx + 1} key={uuid()}>
                  {idx + 1}
                </option>
              );
            })}
          </select>
        </div>
        {maxChildCount > 0 && (
          <div className="newSelection">
            <p
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedInfantCount ===
                    0 && "#dadada",
              }}
            >
              {t("children")}:{" "}
              <span>
                ({childAgeSplit}
                {t("years")} - {childAgeLimit}
                {t("years")})
              </span>{" "}
            </p>
            <select
              className="selectorDrop"
              value={selectedChildCount}
              disabled={
                maxGuestCount - selectedAdultCount - selectedInfantCount === 0
              }
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedInfantCount ===
                    0 && "#dadada",
              }}
              name="sChild"
              onChange={(e) => {
                setSelectedChildCount(Number(e.target.value));
                fireGtmEvent("child_dropdown_clicked", {
                  count: e.target.value,
                  roomIndex: id,
                  room,
                });
                handleChange(e);
              }}
            >
              {/* <option value={0}>Select</option> */}
              {Array.from({
                length: Math.abs(
                  (maxGuestCount - selectedAdultCount - selectedInfantCount >
                  maxChildCount
                    ? maxChildCount
                    : maxGuestCount -
                      selectedAdultCount -
                      selectedInfantCount) + 1
                ),
              }).map((_, idx) => {
                return (
                  <option key={uuid()} value={idx}>
                    {idx === 0 ? "Select" : idx}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {maxInfantCount > 0 && (
          <div className="newSelection">
            <p
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedChildCount ===
                    0 && "#dadada",
              }}
            >
              {t("infants")}:{" "}
              <span>
                (0 - {childAgeSplit - 1}
                {t("years")})
              </span>{" "}
            </p>
            <select
              className="selectorDrop"
              value={selectedInfantCount}
              disabled={
                maxGuestCount - selectedAdultCount - selectedChildCount === 0
              }
              style={{
                color:
                  maxGuestCount - selectedAdultCount - selectedChildCount ===
                    0 && "#dadada",
              }}
              name="sInfant"
              onChange={(e) => {
                setSelectedInfantCount(Number(e.target.value));
                fireGtmEvent("infant_dropdown_clicked", {
                  count: e.target.value,
                  roomIndex: id,
                  room,
                });
                handleChange(e);
              }}
            >
              {Array.from({
                length:
                  (maxGuestCount - selectedAdultCount - selectedChildCount >
                  maxInfantCount
                    ? maxInfantCount
                    : maxGuestCount - selectedAdultCount - selectedChildCount) +
                  1,
              }).map((_, idx) => {
                return (
                  <option key={uuid()} value={idx}>
                    {idx === 0 ? "Select" : idx}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

const RatePlanContainer = ({
  room,
  code,
  rateplan = {},
  extraPrice = 1,
  setAvailableRooms,
  availableRooms,
  maxRoomPerBooking,
  rpRoomCount,
  setRPRoomCount,
  selectedRPRoomCount,
  setSelectedRPRoomCount,
  idx,
  notificationStyle,
  handleRoomPrice,
  pricingfornotifications, // taking from Room function who is taking it from mainpage for notifications on Room and rateplan
  getSecretMemberDealUrl,
  applyPromotion,
  promotionRes,
}) => {
  const rpObject = {
    ...JSON.parse(rateplan?.ratePlanConfig),
    ratePlanId: rateplan?.ratePlanId,
    ratePlanId: rateplan?.ratePlanId,
    id: rateplan?.id,
  };

  const [arrangedPromos, setArrangedPromos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showCancellation, setShowCancellation] = useState(false);
  const [cancellationPolicy, setCancellationPolicy] = useState([]);
  const [suiteRoomsForNotifications, setsuiteRoomsForNotifications] = useState(
    []
  );
  const [secretMemberDetails, setSecretMemberDetails] = useState({
    name: "",
    description: "",
  });
  const [freeCancellationInfo, setFreeCancellationInfo] = useState(null);
  const isSecretMemberUnlocked =
    sessionStorage.getItem("isMembershipUnlocked") === "true";

  const { policies = [] } = rpObject;

  const cancelShown = useMemo(() => {
    let arr = [];
    policies?.forEach((pol) => {
      arr.push(pol);
      // if (!pol?.dates?.start && !pol?.dates?.end) {
      //   arr.push(pol);
      // } else if (
      //   pol?.dates?.start &&
      //   pol?.dates?.end &&
      //   dayjs().isBetween(
      //     dayjs(pol?.dates?.start),
      //     dayjs(pol?.dates?.end),
      //     null,
      //     "[]"
      //   )
      // ) {
      //   arr.push(pol);
      // } else if (
      //   !pol?.dates?.end &&
      //   dayjs(pol?.dates?.start).diff(dayjs(), "days") <= 0
      // ) {
      //   arr.push(pol);
      // } else if (
      //   !pol?.dates?.start &&
      //   dayjs().diff(dayjs(pol?.dates?.end), "days") > 0
      // ) {
      //   arr.push(pol);
      // }
    });
    arr = arr
      .flatMap((ar) => ar?.result)
      .filter(
        (obj, index, self) =>
          index === self.findIndex((o) => o.Days_Before === obj.Days_Before)
      )
      .sort((a, b) => a?.Days_Before - b?.Days_Before);
    // setCancellationPolicy(arr);
    // console.log("pol", arr[0]?.result);

    if (JSON.stringify(arr) !== JSON.stringify(cancellationPolicy)) {
      setCancellationPolicy(arr);
    }
    return arr;
  }, [policies]);

  const {
    pricing,
    maxAdultCount,
    maxChildCount,
    maxGuestCount,
    pricingAdditionalGuests = {},
    maxInfantCount,
  } = room;

  const dispatch = useDispatch();

  const isVRHotel = storageService.get("source") === "google_vr";

  const {
    hotelData,
    totalAdult,
    totalChild,
    totalInfant,
    dateRange,
    totalPeople,
    dateCount,
    selectedRatePlans = [],
    promotions = [],
    taxes,
    isHourlyRoom,
    // pricingfornotifications = [],
  } = useSelector((state) => state.hotelInfo);

  useEffect(() => {
    const filterLowestPriceRooms = (roomsArray) => {
      const lowestPrices = new Map();

      roomsArray?.forEach((roomObj) => {
        const [[roomName, price]] = Object.entries(roomObj);

        if (roomName?.toLowerCase().includes("suite")) {
          if (
            !lowestPrices.has(roomName) ||
            price < lowestPrices.get(roomName)
          ) {
            lowestPrices.set(roomName, price);
          }
        }
      });

      return Array.from(lowestPrices).map(([roomName, price]) => ({
        roomName: roomName,
        roomPrice: price,
      }));
    };

    if (pricingfornotifications?.length > 0) {
      let x = filterLowestPriceRooms(pricingfornotifications);
      let final = x?.slice(0, 2);
      setTimeout(() => {
        if (final?.length > 0) {
          setsuiteRoomsForNotifications(final);
        }
      }, 0);
    }
  }, [pricingfornotifications]);

  const [searchData, setSearchData] = useState([]);
  const [showRatePlanModal, setShowRatePlanModal] = useState(false);
  const [truncatedDesc, setTruncatedDesc] = useState({
    isTruncated: false,
    displayText: "",
  });

  useEffect(() => {
    if (promotions?.length > 0) {
      let ar = arrangePromos(promotions);
      setArrangedPromos(ar);
    } else {
      setArrangedPromos([]);
    }
  }, [promotions, hotelData?.id]);

  let maxAdlt =
    room?.maxAdultCount >
    pricing?.filter((rm) => rm?.ratePlanCode === code)?.length
      ? pricing?.filter((rm) => rm?.ratePlanCode === code)?.length
      : room?.maxAdultCount;

  let aCount = totalAdult <= maxAdlt ? totalAdult : maxAdlt;
  let cCount = 0;
  let iCount = 0;

  const inventoryCount = room?.availableRooms;

  function distributeGuests(
    totalAdults,
    totalChildren,
    totalInfants,
    roomQuantity,
    maxGuests,
    maxAdults,
    maxChildren,
    maxInfants
  ) {
    let rooms = [];
    let remainingAdults = totalAdults;
    let remainingChildren = totalChildren;
    let remainingInfants = totalInfants;

    if (
      (totalChildren > 0 && !maxChildren) ||
      (totalInfants > 0 && !maxInfants)
    ) {
      return [];
    }

    let minRoomsNeeded = Math.ceil(totalAdults / maxAdults);
    minRoomsNeeded = Math.max(
      minRoomsNeeded,
      Math.ceil((totalAdults + totalChildren + totalInfants) / maxGuests)
    );

    if (roomQuantity < minRoomsNeeded) {
      return [];
    }

    for (let i = 0; i < roomQuantity; i++) {
      let roomAdults = 0;
      let roomChildren = 0;
      let roomInfants = 0;

      if (remainingInfants > 0 && remainingAdults > 0) {
        roomInfants = Math.min(remainingInfants, maxInfants, maxGuests - 1); // At least one adult must be in the room
        roomAdults = Math.min(
          remainingAdults,
          maxAdults,
          maxGuests - roomInfants
        );

        let spaceLeft = maxGuests - roomAdults - roomInfants;
        if (spaceLeft > 0 && remainingChildren > 0) {
          roomChildren = Math.min(remainingChildren, maxChildren, spaceLeft);
        }
      } else if (remainingChildren > 0 && remainingAdults > 0) {
        roomChildren = Math.min(remainingChildren, maxChildren, maxGuests - 1); // At least one adult must be in the room
        roomAdults = Math.min(
          remainingAdults,
          maxAdults,
          maxGuests - roomChildren
        );
      } else if (remainingAdults > 0) {
        roomAdults = Math.min(remainingAdults, maxAdults, maxGuests);
      }

      remainingInfants -= roomInfants;
      remainingChildren -= roomChildren;
      remainingAdults -= roomAdults;

      rooms.push({
        adults: roomAdults,
        children: roomChildren,
        infants: roomInfants,
      });

      // If all guests are accommodated, break the loop
      if (
        remainingAdults === 0 &&
        remainingChildren === 0 &&
        remainingInfants === 0
      ) {
        break;
      }
    }

    // If there are still remaining guests after using all rooms, return an empty array
    if (remainingAdults > 0 || remainingChildren > 0 || remainingInfants > 0) {
      return [];
    }

    return rooms;
  }

  const getLowestPrice = (
    adultCount,
    childCount,
    infantCount,
    minorObj,
    pricing
  ) => {
    let totalGuest = adultCount + childCount + infantCount;

    let adultPricing =
      pricing?.filter((pr) => pr?.adultCount === adultCount)?.[0]
        ?.priceForPax || [];

    let childPricing = minorObj?.children;
    let infantPricng = minorObj?.infants;

    let dates = adultPricing?.map((date) => date?.checkInDate) || [];

    let rpArr = [];

    dates.forEach((date) => {
      let sum = 0,
        tax = 0;

      // calculate adult price
      sum += adultPricing?.filter((dt) => dt?.checkInDate === date)?.[0]
        ?.priceBeforeTax;

      if (childCount > 0) {
        let datePrice = childPricing?.filter(
          (dt) => dt?.checkInDate === date
        )[0]?.priceBeforeTax;
        let childPrice = 0;
        for (let i = 0; i < childCount; i++) {
          childPrice += datePrice;
        }

        if (pricing?.some((pr) => pr?.adultCount === adultCount + childCount)) {
          let extraAdultComparePrice =
            pricing?.filter(
              (pr) => pr?.adultCount === adultCount + childCount
            )?.[0]?.priceForPax || [];
          let priceForThis = extraAdultComparePrice?.filter(
            (pr) => pr?.checkInDate === date
          )?.[0]?.priceBeforeTax;
          sum = Math.min(priceForThis, sum + childPrice);
        }
      }
      if (infantCount > 0) {
        // compare the price with child and swap it with infant;
        let childDatePrice = childPricing?.filter(
          (dt) => dt?.checkInDate === date
        )[0]?.priceBeforeTax;

        let infantDatePrice = infantPricng?.filter(
          (dt) => dt?.checkInDate === date
        )[0]?.priceBeforeTax;

        let infantPrice = Math.min(childDatePrice, infantDatePrice);
        let price = 0;
        for (let i = 0; i < infantCount; i++) {
          price += infantPrice;
        }

        if (
          pricing?.some(
            (pr) => pr?.adultCount === adultCount + infantCount + childCount
          )
        ) {
          let extraAdultComparePrice =
            pricing?.filter(
              (pr) => pr?.adultCount === adultCount + infantCount + childCount
            )?.[0]?.priceForPax || [];
          let priceForThis = extraAdultComparePrice?.filter(
            (pr) => pr?.checkInDate === date
          )?.[0]?.priceBeforeTax;
          sum = Math.min(priceForThis, sum + price);
        }
      }
      let obj = {
        checkInDate: date,
        priceBeforeTax: sum,
      };
      rpArr.push(obj);
    });

    return rpArr;
  };

  const { price, taxAmount, priceReduced } = useMemo(() => {
    let sum = 0,
      tax = 0,
      promosApplied = [],
      priceReduced = 0;

    let searchedRooms = distributeGuests(
      totalAdult,
      totalChild,
      totalInfant,
      availableRooms,
      room?.maxGuestCount,
      maxAdlt,
      room?.maxChildCount,
      room?.maxInfantCount
    );

    if (searchedRooms.length > 0) {
      setSearchData(searchedRooms);

      for (let i = 0; i < searchedRooms.length; i++) {
        let tempArr = getLowestPrice(
          searchedRooms[i]?.adults,
          searchedRooms[i]?.children,
          searchedRooms[i]?.infants,
          pricingAdditionalGuests[code],
          pricing?.filter((r) => r?.ratePlanCode === code)
        );

        tempArr?.forEach((obj, idx) => {
          let tempPrice = obj?.priceBeforeTax;
          let checkInDate = obj?.checkInDate;

          const promo = getApplicablePromotionRoom({
            arrangedPromos: promotions,
            rp: { rpObject, roomId: room?.id },
            tempPrice,
            checkInDate,
          });

          if (promo) {
            promosApplied.push(promo);
          }

          // if (hotelData?.userId !== 63809) {
          //   tempPrice = tempPrice > 7500 ? tempPrice * 1.18 : tempPrice * 1.12;
          // }

          let { finalValue, reducedPrice } = calculatePromotion({
            price: tempPrice,
            promo,
            idx,
            dateCount,
          });
          priceReduced += reducedPrice;

          const taxObj = getCalculatedTax({
            rooms: [{ id: room?.id, amount: finalValue }],
            isInclusive: hotelData?.isTaxIncluded,
            taxes: taxes,
            noOfNights: 1,
          });

          sum += finalValue;
          tax += taxObj?.totalRoomTax;
        });
      }
    } else {
      setSearchData([]);
      let tempArr =
        pricing?.filter(
          (pr) =>
            pr?.adultCount === aCount &&
            pr?.childCount === 0 &&
            pr?.infantCount === 0 &&
            pr?.ratePlanCode === code
        )?.[0]?.priceForPax || [];

      tempArr?.forEach((obj, idx) => {
        let tempPrice = obj?.priceBeforeTax;
        let checkInDate = obj?.checkInDate;

        const promo = getApplicablePromotionRoom({
          arrangedPromos: promotions,
          rp: { rpObject, roomId: room?.id },
          tempPrice,
          checkInDate,
        });

        if (promo) {
          promosApplied.push(promo);
        }

        // if (hotelData?.userId !== 63809) {
        //   tempPrice = tempPrice > 7500 ? tempPrice * 1.18 : tempPrice * 1.12;
        // }

        let { finalValue, reducedPrice } = calculatePromotion({
          price: tempPrice,
          promo,
          idx,
          dateCount,
        });
        priceReduced += reducedPrice;

        const taxObj = getCalculatedTax({
          rooms: [{ id: room?.id, amount: finalValue }],
          isInclusive: hotelData?.isTaxIncluded,
          taxes: taxes,
          noOfNights: 1,
        });

        sum += finalValue;
        tax += taxObj?.totalRoomTax;
      });
    }

    if (sum > 0) {
      const lowestPrice = storageService.get("lowestPrice") ?? Infinity;
      storageService.set("lowestPrice", Math.min(lowestPrice, sum + tax));
    }

    return {
      price: Number(sum),
      taxAmount: Number(tax),
      priceReduced: Number(priceReduced),
    };
  }, [
    pricing,
    totalAdult,
    totalChild,
    totalInfant,
    arrangedPromos,
    taxes,
    dateRange,
  ]);

  useEffect(() => {
    if (!room || !price || !handleRoomPrice) return;
    handleRoomPrice(room?.roomName, price);
  }, [room, price]);

  // useEffect(() => {
  //   if (!room || !price) return;
  //   // console.log(
  //   //   "room.roomName and price that will be passed to handleRoomPrice function",
  //   //   room.roomName,
  //   //   price
  //   // );
  //   dispatch({
  //     type: hotelInfoTypes.PRICE_FOR_NOTIFICATIONS,
  //     payload: { [room.roomName]: price },
  //   });
  // }, [room, price]);

  const selectedCount = useMemo(() => {
    return selectedRatePlans?.filter(
      (rp) => rp?.id === `${room?.id}_${code}_${idx}`
    )?.length;
  }, [selectedRatePlans]);

  const thisSelectedRateplans = useMemo(() => {
    return selectedRatePlans?.filter(
      (rp) => rp?.id === `${room?.id}_${code}_${idx}`
    );
  }, [selectedRatePlans]);

  const thisRoomCount = useMemo(() => {
    return selectedRatePlans?.filter((rp) => rp?.roomId === room?.id)?.length;
  }, [selectedRatePlans]);

  const [thisRoomIndex] = useMemo(() => {
    return selectedRatePlans
      ?.filter((rp) => rp?.roomId === room?.id && code === rp?.code)
      ?.sort((a, b) => a?.index - b?.index)
      ?.slice(-1);
  }, [selectedRatePlans]);

  const increment = async () => {
    console.log("called?");
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    if (maxRoomPerBooking && selectedRatePlans?.length >= maxRoomPerBooking) {
      toastr.error(
        `Hotel does not allow more than ${maxRoomPerBooking} rooms in a single reservation.`
      );
      setIsLoading(false);
      return;
    }

    let resp = await checkRoomCount(thisRoomCount + 1);
    if (!resp) {
      setIsLoading(false);
      return;
    }

    try {
      if (thisRoomCount < availableRooms) {
        let obj = {
          sAdult: aCount,
          sChild: 0, //cCount,
          sInfant: 0, //iCount,
          code,
          roomId: room?.id,
          rpObject,
          id: `${room?.id}_${code}_${idx}`,
          idx: (thisRoomIndex?.idx || 0) + 1,
          RoomImages: room?.RoomImages,
          roomName: room?.roomName,
        };
        fireGtmEvent("room_added", obj);
        if (window) {
          window?.gtag("event", "add_to_cart", {
            value: price,
            currency: hotelData?.currency,
            items: [
              {
                id: hotelData?.id,
                start_date: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
                end_date: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
                google_business_vertical: "hotel_rental",
              },
            ],
          });
        }
        if (hotelData?.userId === 103376 && window?.gtag) {
          window?.gtag("event", "add_to_cart", {
            value: price,
            currency: hotelData?.currency,
            items: [
              {
                price: price, // Room price per night
                item_id: hotelData?.id, // Room ID or SKU
                item_name: room?.roomName, // Room name
              },
            ],
          });
        }
        let obj2 = {
          hotelId: hotelData?.id,
          roomIds: [obj?.roomId],
          checkInDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
          checkOutDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
          roomCount: thisRoomCount + 1,
        };
        dispatch(addRatePlan(obj, obj2, 0, () => setIsLoading(false)));
        addRatePlanAds();
      } else {
        toastr.error(t("Maximum room count reached!"));
        setIsLoading(false);
        fireGtmEvent("room_availability_error", {
          hotelId: hotelData?.id,
          roomIds: [room?.id],
          checkInDate: dayjs(dateRange?.startDate).format("YYYY-MM-DD"),
          checkOutDate: dayjs(dateRange?.endDate).format("YYYY-MM-DD"),
          roomCount: thisRoomCount,
        });
      }
    } catch (error) {
      fireGtmEvent("add_rp_error", error);
      setIsLoading(false);
    }
  };

  let matchedRoom = hotelData?.HotelRooms?.find((r) => r.id === room?.id);
  const checkRoomCount = async (roomCount = 1) => {
    const utmObj = storageService.get("utmObj");
    if (utmObj?.googleSource === "verification") {
      return roomCount;
    }
    let obj = {
      hotelId: hotelData?.id,
      roomIds: [room?.id],
      checkInDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
      checkOutDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
      roomCount,
      initialRoomCount: matchedRoom?.availableRooms ?? 0,
    };

    const response = await isRoomAvailableApi(obj);

    dispatch({
      type: hotelInfoTypes.SET_UPDATED_ROOM_COUNT,
      payload: { id: room?.id, value: response?.data },
    });
    if (!response?.data) {
      setAvailableRooms(response?.data);
      fireGtmEvent("room_availability_error", obj);
      toastr.error("Room sold out, please select other available room.");
    }
    return response?.data;
  };

  const addRatePlanAds = () => {
    if (window) {
      window?.gtag("event", "conversion", {
        send_to: "AW-10960259904/_RXWCJnb3MwZEMCWoeoo",
        value: price + taxAmount,
        currency: hotelData?.currency,
        event_callback: () => {},
      });
    }
  };

  const handleSearchData = async () => {
    if (isLoading) {
      return;
    }
    if (maxRoomPerBooking && selectedRatePlans?.length >= maxRoomPerBooking) {
      toastr.error(
        `Hotel does not allow more than ${maxRoomPerBooking} rooms in a single reservation.`
      );
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    let resp = await checkRoomCount(thisRoomCount + searchData.length);
    if (!resp) {
      setIsLoading(false);
      return;
    }

    try {
      fireGtmEvent("searchRoom_added", { searchData, room });
      searchData.forEach((sd, indx) => {
        if (thisRoomCount >= availableRooms) {
          toastr.error(t("Maximum room count reached!"));
          setIsLoading(false);
          return;
        }
        let obj = {
          sAdult: sd.adults,
          sChild: sd.children, //cCount,
          sInfant: sd.infants, //iCount,
          code,
          roomId: room?.id,
          rpObject,
          id: `${room?.id}_${code}_${idx}`,
          idx: (indx || 0) + 1,
          RoomImages: room?.RoomImages,
          roomName: room?.roomName,
        };
        let obj2 = {
          hotelId: hotelData?.id,
          roomIds: [obj?.roomId],
          checkInDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
          checkOutDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
          roomCount: thisRoomCount + searchData.length,
        };
        console.log("this called2", obj, obj2, indx);
        dispatch(addRatePlan(obj, obj2, indx, () => setIsLoading(false)));
        addRatePlanAds();
      });
    } catch (error) {
      fireGtmEvent("add_rp_error", error);
      setIsLoading(false);
    }
  };

  const decrement = () => {
    if (thisRoomCount > 0) {
      fireGtmEvent("room_removed", { roomId: room?.id });
      if (hotelData?.userId === 103376 && window && window?.gtag) {
        window?.gtag("event", "remove_from_cart", {
          value: price,
          currency: hotelData?.currency,
          items: [
            {
              price: price, // Room price per night
              item_id: hotelData?.id, // Room ID or SKU
              item_name: room?.roomName, // Room name
            },
          ],
        });
      }
      dispatch({
        type: hotelInfoTypes.DESELECT_RP,
        payload: `${room?.id}_${code}_${idx}`,
      });
    }
  };

  const handleContinueBooking = () => {
    dispatch({
      type: hotelInfoTypes.SET_CONTINUE_BOOKING,
      payload: false,
    });
  };

  const { t } = useTranslation();

  const truncateDescription = (description, limit) => {
    const words = description.split(" ");
    let displayText;

    if (words.length > limit) {
      displayText = words.slice(0, limit).join(" ") + "...";
    } else {
      displayText = description;
    }

    setTruncatedDesc({
      isTruncated: words.length > limit,
      displayText: displayText,
    });
  };

  useEffect(() => {
    truncateDescription(rpObject?.description || "", 10);
  }, [rpObject?.description]);

  const [dropCancellation, setDropCancellation] = useState(false);

  const handleToggleCancellation = () => {
    setDropCancellation(!dropCancellation);
    dropCancellation
      ? fireGtmEvent("cancelClosedLandingPage")
      : fireGtmEvent("cancelViewedLandingPage");
  };

  return (
    <>
      {price > 0 && (
        <>
          <div className="rateplanContainer">
            <div className="ratePlanBox">
              <div className="ratePlanDetails">
                <div className="rpWrapper">
                  {!room?.roomName?.toLowerCase()?.includes("suite") &&
                    rpObject?.name?.toLowerCase()?.includes("room only") &&
                    idx === 0 && (
                      <p
                        style={{
                          ...notificationStyle,
                          marginLeft: "-2px",
                          color: "#5925DC",
                          border: "1px solid #D9D6FE",
                          backgroundColor: "#F4F3FF",
                        }}
                        className="countWidget"
                      >
                        {`Only ${
                          room?.availableRooms > 3
                            ? Math.floor(Math.random() * 2) + 2
                            : room?.availableRooms
                        } ${
                          room?.availableRooms === 1 ? "room" : "rooms"
                        } left at this price!`}
                      </p>
                    )}
                  {room?.roomName?.toLowerCase()?.includes("suite") &&
                    rpObject?.name?.toLowerCase()?.includes("room only") &&
                    idx === 0 &&
                    suiteRoomsForNotifications?.map((ele) =>
                      ele?.roomName === room?.roomName ? (
                        <p
                          style={{
                            ...notificationStyle,
                            marginLeft: "-2px",
                            color: "#5925DC",
                            border: "1px solid #D9D6FE",
                            backgroundColor: "#F4F3FF",
                          }}
                          className="countWidget"
                        >
                          {`Hurry! Only ${
                            room?.availableRooms > 3
                              ? Math.floor(Math.random() * 2) + 2
                              : room?.availableRooms
                          } ${
                            room?.availableRooms === 1 ? "suite" : "suites"
                          } remaining for your dates`}
                        </p>
                      ) : null
                    )}
                  {/* Secret Member deal */}
                  {secretMemberDetails?.name &&
                    secretMemberDetails?.description &&
                    isSecretMemberUnlocked && (
                      <div className="secretMemberTitleBox">
                        <h3>{secretMemberDetails?.name}</h3>
                        <div className="secretMemberVerticalLine"></div>
                        <p>{secretMemberDetails?.description}</p>
                      </div>
                    )}

                  <p style={{ fontWeight: "bold", fontSize: "1rem" }}>
                    {rpObject?.name}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "4px",
                    }}
                  >
                    <p
                      className="rateplanDescription"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {truncatedDesc?.displayText}
                    </p>
                    {truncatedDesc?.isTruncated && (
                      <p
                        className="showInclusionBtn"
                        onClick={() => setShowRatePlanModal(true)}
                      >
                        Show More
                      </p>
                    )}
                  </div>
                  {rpObject?.inclusions?.length &&
                    rpObject?.inclusions?.slice(0, 2)?.map((inc) => (
                      <div key={inc?.id} className="rpInclusionContainer">
                        <div className="rpInclusionBox">
                          <img src={rp_inclusion_icon} />
                          <p>{inc?.inclusionName}</p>
                        </div>
                      </div>
                    ))}
                </div>
                {/* cancellation window */}
                {cancelShown?.length > 0 && (
                  <>
                    {" "}
                    {freeCancellationInfo?.hasFreeCancellation && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",

                          gap: "5px",
                          color: "#006400",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        <span>
                          Book risk free, cancel for free anytime before{" "}
                          {freeCancellationInfo.freeCancellationDate?.format(
                            "h:mm A"
                          )}{" "}
                          on{" "}
                          {freeCancellationInfo.freeCancellationDate?.format(
                            "MMM D, YYYY"
                          )}
                        </span>
                      </div>
                    )}
                  </>
                )}

                <div className="inclusionBox">
                  {rpObject?.inclusions?.length > 2 && (
                    <p
                      className="showInclusionBtn"
                      onClick={() => setShowRatePlanModal(true)}
                    >
                      See all inclusions
                    </p>
                  )}

                  {/* <div style={{background: "black", width: "8px", height:"8px", borderRadius: "100%"}}></div> */}
                  {cancelShown.length > 0 && (
                    <>
                      <p
                        onClick={handleToggleCancellation}
                        className="policyLabel"
                        style={{ cursor: "pointer" }}
                      >
                        {t("cancellation_refund_policy")}
                      </p>
                    </>
                  )}
                </div>
              </div>
              <div className="rateplanInfo">
                <div className="ratePlanPriceBox">
                  <div className="rateplanName">
                    {priceReduced > 0 ? (
                      <div>
                        <b
                          style={{
                            fontSize: "0.8rem",
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <p className="discountedPrice">
                            {currency(hotelData?.currency)}{" "}
                            {/* {((price + priceReduced) * extraPrice).toFixed(
                            getFixedValue(hotelData?.currency)
                          )} */}
                            {(
                              ((price + priceReduced) * extraPrice) /
                              dateCount
                            ).toFixed(getFixedValue(hotelData?.currency))}
                          </p>
                          <p
                            // className="discountedPrice"
                            style={{
                              textDecoration: "none",
                              color: "var(--green)",
                            }}
                          >
                            {currencies(hotelData?.currency)}{" "}
                            {Number(
                              (priceReduced * extraPrice) / dateCount
                            ).toFixed(getFixedValue(hotelData?.currency))}{" "}
                            {t("off")}
                          </p>
                        </b>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "2px",
                          }}
                        >
                          <p style={{ fontSize: "1.1rem" }}>
                            {currency(hotelData?.currency)}{" "}
                            {((price * extraPrice) / dateCount).toFixed(
                              getFixedValue(hotelData?.currency)
                            )}{" "}
                            /{" "}
                          </p>
                          <p>
                            {dateCount === 1 ? t("night") : `${t("Night")}`}
                            {/* {dateCount === 1
                              ? t("night")
                              : `${dateCount / dateCount} ${t("night")}`} */}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        <p>
                          {currency(hotelData?.currency)}{" "}
                          {Number(price / dateCount).toFixed(
                            getFixedValue(hotelData?.currency)
                          )}{" "}
                          /{" "}
                        </p>
                        <p>{dateCount === 1 ? t("night") : ` ${t("night")}`}</p>
                      </div>
                    )}
                    {taxAmount > 0 && (
                      <p style={{ color: "#4a4a4a", fontSize: "0.8rem" }}>
                        <span>{t("Plus")} </span>
                        {/* {Number((taxAmount * extraPrice) / dateCount).toFixed(
                          getFixedValue(hotelData?.currency)
                        )}{" "} */}
                        {t("taxes")}
                      </p>
                    )}
                    {searchData.length > 0 ? (
                      <p>
                        {" "}
                        {t("price_for")} {totalPeople}{" "}
                        {t(pluralWords(totalPeople, "guest"))}
                      </p>
                    ) : (
                      <p>
                        {" "}
                        {t("price_for")} {aCount}{" "}
                        {t(pluralWords(aCount, "Adult"))}
                      </p>
                    )}
                    {isVRHotel ? (
                      <span>
                        (This room can accommodate up to {maxGuestCount || 1}{" "}
                        guests)
                      </span>
                    ) : null}
                  </div>

                  <div className="rateplanPrice">
                    {selectedCount === 0 ? (
                      <div
                        className="selectRoomRoom"
                        onClick={() => {
                          handleContinueBooking();
                          if (searchData.length > 0) {
                            handleSearchData();
                          } else {
                            increment();
                          }
                        }}
                      >
                        {isLoading ? <CircleLoader /> : t("select")}
                      </div>
                    ) : (
                      <div
                        className="incrementer roomCom"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <div onClick={decrement} className="decrement roomInc">
                          -
                        </div>
                        <div className="incrementer__value roomVal">
                          {selectedCount}
                        </div>

                        <div onClick={increment} className="increment roomInc">
                          +
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="newSelectionContainer">
              {Array.from({ length: selectedCount }).map((_, id) => {
                return (
                  <RateplanSlot
                    thisPlan={thisSelectedRateplans[id]}
                    id={id + 1}
                    defaultGuestCount={room?.defaultGuestCount}
                    maxAdultCount={maxAdlt}
                    maxGuestCount={maxGuestCount}
                    key={id}
                    childAgeSplit={room?.childAgeSplit || 12}
                    childAgeLimit={room?.childAgeLimit || 18}
                    extraChildPrice={
                      room?.pricingAdditionalGuests?.[code]?.["children"]
                    }
                    extraInfantPrice={
                      room?.pricingAdditionalGuests?.[code]?.["infants"]
                    }
                    room={room}
                  />
                );
              })}
            </div>
            {/* secret member rate box */}
            {availableRooms > 0 && (
              <SecretMemberDeal
                price={
                  priceReduced > 0
                    ? ((price + priceReduced) * extraPrice).toFixed(
                        getFixedValue(hotelData?.currency)
                      )
                    : Number(price).toFixed(getFixedValue(hotelData?.currency))
                }
                isRatePlan={true}
                getMembershipDetails={(name, description) =>
                  setSecretMemberDetails({ name, description })
                }
                getSecretMemberDealUrl={getSecretMemberDealUrl}
                applyPromotion={applyPromotion}
                promotionRes={promotionRes}
              />
            )}
          </div>
          <div style={{ width: "100%" }}>
            {cancelShown.length > 0 && (
              <div
                className="newSelectionContainer"
                style={{
                  width: "fit-content",
                  cursor: "pointer",
                }}
              >
                <CancellationPolicy
                  cancellationPolicy={cancellationPolicy}
                  setCancellationPolicy={setCancellationPolicy}
                  dateRange={dateRange}
                  // checkInTime={checkInTime}
                  noMargin={true}
                  rpObject={rpObject}
                  cancelShown={cancelShown}
                  room={room}
                  showCancellation={dropCancellation}
                  onFreeCancellationData={setFreeCancellationInfo}
                />

                {/* <p
            style={{
              fontSize: "0.7rem",
              textDecoration: "underline",
            }}
            onClick={() => {
              setShowCancellation(true);
              fireGtmEvent("rpCancellationOpened", {
                room_rp_id: `${room?.id}_${code}_${idx}`,
              });
            }}
          >
            {t("cancellation_policy")}
          </p> */}
              </div>
            )}
            {showCancellation && (
              <Drawer isOpen={showCancellation} setIsOpen={setShowCancellation}>
                <div className="rpCancelPolicyContainer">
                  <div className="rpCancelClose">
                    <p>{t("cancellation_policy")}</p>
                    <p
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowCancellation(false)}
                    >
                      X
                    </p>
                  </div>
                  <div className="rpCancelPolicy">
                    {cancelShown?.some((res) => res?.Days_Before == 999) ? (
                      <p>
                        Non Refundable - 100% of the money will be charged upon
                        cancellation.
                      </p>
                    ) : (
                      cancelShown.map((res, idx) => {
                        let obj = {
                          nights: "nights",
                          percent: "%",
                          fixed: hotelData?.currency,
                        };
                        return (
                          <p key={idx}>
                            •{" "}
                            {res?.Days_Before === 0
                              ? `${t(
                                  "Incase of No Show / Cancelling on day of Checkin will incur"
                                )} ${res?.Penalty_Value}${
                                  obj[res?.Penalty_Type]
                                } ${t("penalty")}.`
                              : res?.Penalty_Type === "nights"
                              ? `${t("Cancelling")} ${
                                  res?.Days_Before
                                } ${pluralWords(res?.Days_Before, "day")}  ${t(
                                  "before arrival incurs a"
                                )} ${res?.Penalty_Value}${pluralWords(
                                  res?.Penalty_Value,
                                  "night"
                                )} ${t("penalty")}.`
                              : `${t("Cancelling")} ${
                                  res?.Days_Before
                                } ${pluralWords(res?.Days_Before, "day")}  ${t(
                                  "before arrival incurs a"
                                )} ${res?.Penalty_Value}${
                                  obj[res?.Penalty_Type]
                                } ${t("penalty")}.`}
                          </p>
                        );
                      })
                    )}
                  </div>
                </div>
              </Drawer>
            )}
          </div>
        </>
      )}
      {showRatePlanModal && (
        <RatePlanModal
          onClose={() => setShowRatePlanModal(false)}
          rpObject={rpObject}
          room={room}
        />
      )}
    </>
  );
};

const Room = ({
  room,
  showFakePrice = false,
  extraPrice = 1,
  totalPeople,
  dateRange,
  lastDates,
  isFirst = false,
  showLoyal,
  isModify = false,
  isSelected = false,
  handleRoomPrice,
  pricingfornotifications,
  getSecretMemberDealUrl,
  applyPromotion,
  promotionRes,
  adults,
  child,
}) => {
  const {
    id,
    roomName = "Single Room",
    defaultPrice,
    defaultGuestCount,
    RoomImages,
    pricing,
    availableRooms: a1Rooms,
    HotelRoomAddons,
    HotelRoomAmenities,
    maxGuestCount,
    hourly = [],
    priceConfig = {},
    chosenPriceConfig,
    priceConfigDifference = {},
  } = room;

  const [price, setPrice] = useState(defaultPrice);
  const [roomCount, setRoomCount] = useState(0);
  const [viewImage, setViewImage] = useState(false);
  const [, setPeople] = useState(0);
  const [extraAdult, setExtraAdult] = useState(0);
  const [extraChild, setExtraChild] = useState(0);
  const [availableRooms, setAvailableRooms] = useState();
  const [size, setSize] = useState(300);
  const [isDorm, setIsDorm] = useState(false);
  const [shouldAdd, setShouldAdd] = useState(true);
  const [cancellationPolicy, setCancellationPolicy] = useState();
  const [showCancel, setShowCancel] = useState(false);
  const [, setLastDate] = useState();
  const [partialPercentage, setPartialPercentage] = useState();
  const [isCOD, setIsCOD] = useState(false);
  const [freeFood, setFreeFood] = useState();
  const [freeGuest, setFreeGuest] = useState([]);
  const [dinner, setDinner] = useState(0);
  const [lunch, setLunch] = useState(0);
  const [breakfast, setBreakfast] = useState(0);
  const [priceToDisplay, setPriceToDisplay] = useState();
  const [guestToDisplay, setGuestToDisplay] = useState();
  const [taxAmt, setTax] = useState();
  const [excludedPrice, setExcludedPrice] = useState(0);
  const [addons, setAddons] = useState(HotelRoomAddons);
  const [adultAddons, setAdultAddons] = useState([]);
  const [compareAdultAddons, setCompareAdultAddons] = useState([]);
  const [extraInfant, setExtraInfant] = useState(0);
  const [aRooms, setARooms] = useState();
  const [rpRoomCount, setRPRoomCount] = useState(0);
  const [selectedRPRoomCount, setSelectedRPRoomCount] = useState(0);
  const [arrangedPromos, setArrangedPromos] = useState([]);

  const [searchGuestCount, setSearchGuestCount] = useState(2);
  const [searchRoomCount, setSearchRoomCount] = useState(0);
  const [useSearchData, setUseSearchData] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [visibleItems, setVisibleItems] = useState([]);
  const [showEllipsis, setShowEllipsis] = useState(false);
  const [notifications, setnotifications] = useState([]);
  const [randomNumber, setRandomNumber] = useState(7);
  const [peopleViewing, setpeopleViewing] = useState(2);
  const [bookedMinutesAgo, setbookedMinutesAgo] = useState(10);
  const [secretMemberDetails, setSecretMemberDetails] = useState({
    name: "",
    description: "",
  });
  const [showRetargModal, setShowRetargModal] = useState(false);
  const isSecretMemberUnlocked =
    sessionStorage.getItem("isMembershipUnlocked") === "true";

  // new room selection
  const [selectedRoomCount, setSelectedRoomCount] = useState(-1);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [percentageguests, setpercentageguests] = useState();
  const [hoverNotify, setHoverNotify] = useState(false);

  HotelRoomAddons.sort((a, b) => a.price - b.price);

  const isVRHotel = storageService.get("source") === "google_vr";

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const windowSize = useWindowSize();

  const descriptionRef = useRef();

  const {
    selectedRooms,
    hotelData,
    selectedAddons,
    totalAdult,
    totalChild,
    promotions = [],
    policies,
    payments,
    isHourlyRoom,
    isRatePlans,
    roomSlots,
    hourlyTime,
    dateCount,
    taxes,
    updatedRoomCount = {},
    hourlyDate,
    // pricingfornotifications = [],
  } = useSelector((state) => state.hotelInfo);
  const [isRoomDescOpen, setRoomDescOpen] = useState(false);

  //Real-Time Booking Alerts and Popularity Signals - Starts
  useEffect(() => {
    const filterLowestPriceRooms = (roomsArray) => {
      const lowestPrices = new Map();

      roomsArray?.forEach((roomObj) => {
        const [[roomName, price]] = Object.entries(roomObj);
        if (!lowestPrices.has(roomName) || price < lowestPrices.get(roomName)) {
          lowestPrices.set(roomName, price);
        }
      });

      return Array.from(lowestPrices).map(([roomName, price]) => ({
        [roomName]: price,
      }));
    };

    if (pricingfornotifications?.length > 0) {
      let x = filterLowestPriceRooms(pricingfornotifications);
      let final = x?.slice(0, 4);

      setTimeout(() => {
        if (final?.length > 0) {
          setnotifications(final);
        }
      }, 0);
    }
  }, [pricingfornotifications]);

  const notificationDivStyle =
    windowSize.width <= 900
      ? {
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          marginTop: "1vh",
          paddingLeft: "10px",
          gap: "2px",
          alignItems: "center",
        }
      : {
          width: "100%",
          display: "flex",
          marginTop: "0",
          left:
            windowSize?.width > 900 && windowSize?.width <= 1250
              ? "315px"
              : "26.5vw",
          bottom: "10px",
          right: "0px",
          top: "10px",
          gap: "2px",
          alignItems: "center",
        };

  const notificationStyle = {
    fontWeight: "500",
    color: "#026AA2",
    backgroundColor: "#F0F9FF",
    border: "1px solid #B9E6FE",
    width: "fit-content",
    padding: "2px 8px 2px 8px",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    gap: "3px",
    marginLeft: "3px",
  };

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerHTML = `
      @keyframes blink-border {
        0% { border-color: #B9E6FE; }
        50% { border-color: transparent; }
        100% { border-color: #B9E6FE; }
      }

      @keyframes blink-icon {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
      }
    `;
    document.head.appendChild(styleSheet);
  }, []);

  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function checkAndSaveRandomNumber() {
    try {
      const savedData = localStorage.getItem("bookingNumber");

      if (savedData) {
        const parts = savedData.split("|");
        if (parts?.length === 2) {
          const savedNumber = parseInt(parts[0], 10);
          const savedDateStr = parts[1];

          const today = new Date();
          const todayStr = `${today.getFullYear()}-${String(
            today.getMonth() + 1
          ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

          if (savedDateStr === todayStr) {
            return savedNumber;
          }
        }
      }

      const randomNumber = generateRandomNumber(5, 15);
      const today = new Date();
      const todayStr = `${today?.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today?.getDate()).padStart(2, "0")}`;

      const dataToStore = `${randomNumber}|${todayStr}`;

      try {
        localStorage.setItem("bookingNumber", dataToStore);
      } catch (err) {
        console.log(err);
      }

      return randomNumber;
    } catch (error) {
      console.log(error);
      return generateRandomNumber(5, 15);
    }
  }

  useEffect(() => {
    const number = checkAndSaveRandomNumber();

    if (number) {
      setRandomNumber(number);
    }
  }, []);

  useEffect(() => {
    let randomNumber = Math.floor(Math.random() * (10 - 2 + 1) + 2);

    if (randomNumber) {
      setpeopleViewing(randomNumber);
    }
  }, []);

  useEffect(() => {
    let randomNumber = Math.floor(Math.random() * (30 - 10 + 1) + 10);
    if (randomNumber) {
      setbookedMinutesAgo(randomNumber);
    }
  }, []);

  const getRoomNotification = (
    notifications,
    room,
    peopleViewing,
    bookedMinutesAgo,
    randomNumber,
    hotelData
  ) => {
    const roomIndex = notifications?.findIndex(
      (notification) => Object.keys(notification)[0] === room?.roomName
    );

    switch (roomIndex) {
      case 0:
        return (
          <p
            style={{
              ...notificationStyle,
              animation: "blink-border 1.0s infinite",
            }}
            className="countWidget"
          >
            <img
              src={viewIcon}
              alt="View Icon"
              style={{ animation: "blink-icon 1.0s infinite" }}
            />
            <span>{peopleViewing} people are viewing this room right now</span>
          </p>
        );
      case 1:
        return (
          <p style={notificationStyle} className="countWidget">
            Someone booked this room {bookedMinutesAgo} minutes ago
          </p>
        );
      case 2:
        return (
          <p style={notificationStyle} className="countWidget">
            This room was booked {randomNumber} times in last 7 days
          </p>
        );
      case 3:
        return hotelData?.city ? (
          <p style={notificationStyle} className="countWidget">
            Highly rated by travelers visiting {hotelData.city}
          </p>
        ) : (
          <p style={notificationStyle} className="countWidget">
            Highly rated by travelers
          </p>
        );
      default:
        return null;
    }
  };
  //Real-Time Booking Alerts and Popularity Signals - Ends

  const truncateDescription = (text, wordLimit = 20) => {
    const lines = text?.split("\n") || [];
    return { truncatedLines: lines, isTruncated: true };
    const firstLineWords = lines[0]?.trim().split(" ") || [];
    const secondLineWords = lines[1]?.trim().split(" ") || [];

    let truncatedLines = [];
    let isTruncated = false;

    if (firstLineWords.length > wordLimit) {
      truncatedLines = [firstLineWords.slice(0, wordLimit).join(" ") + "..."];
      isTruncated = true;
    } else if (secondLineWords.length > wordLimit || lines.length > 2) {
      truncatedLines = [
        lines[0],
        secondLineWords.slice(0, wordLimit).join(" ") + "...",
      ];
      isTruncated = true;
    } else {
      truncatedLines = lines.slice(0, 2);
    }

    return { truncatedLines, isTruncated };
  };

  const { truncatedLines, isTruncated } = truncateDescription(
    room?.description
  );

  useEffect(() => {
    if (a1Rooms && a1Rooms > 0) {
      if (hotelData?.userId === 63809) {
        a1Rooms > 5 ? setARooms(5) : setARooms(a1Rooms);
      } else {
        setARooms(a1Rooms);
      }
    } else {
      setARooms(0);
    }
  }, [a1Rooms]);

  useEffect(() => {
    const filterRooms = selectedRooms;
    const findRoom = filterRooms?.filter((rm) => rm?.id === room?.id);
    const filterAddons = selectedAddons?.filter(
      (adn) => adn?.hotelRoomId === room?.id
    );
    setRoomCount(findRoom?.length);
    if (findRoom?.length === 0 && filterAddons?.length === 0) {
      setExtraAdult(0);
      setExtraChild(0);
      setExtraInfant(0);
      setDinner(0);
      setLunch(0);
      setBreakfast(0);
    }
  }, [roomCount, selectedAddons, selectedRooms]);

  useEffect(() => {
    const checkOverflow = () => {
      if (descriptionRef.current) {
        setIsOverflowing(
          descriptionRef.current.scrollHeight >
            descriptionRef.current.clientHeight
        );
      }
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [descriptionRef.current]);

  useEffect(() => {
    if (
      HotelRoomAmenities?.some(
        (amn) =>
          amn?.Amenity?.name === "Bunk Beds" &&
          amn?.Amenity?.category === "bed_type"
      )
    ) {
      setIsDorm(true);
    }
  }, [selectedRooms]);

  useEffect(() => {
    if (HotelRoomAddons?.length > 0) {
      let tempFood = HotelRoomAddons?.filter(
        (adn) => adn?.price === "0.00" && adn?.Addon?.category === "meal"
      );
      setFreeFood(tempFood);

      let tempGuest = HotelRoomAddons?.filter(
        (adn) => adn?.price === "0.00" && adn?.Addon?.category === "person"
      );
      setFreeGuest(tempGuest);
    }
  }, []);

  useEffect(() => {
    if (payments) {
      if (payments?.some((pay) => pay?.Gateway?.name === "COD")) {
        setIsCOD(true);
      }
      if (payments?.some((pay) => pay?.Gateway?.name === "PartialPayment")) {
        let val = payments?.filter(
          (pay) => pay?.Gateway?.name === "PartialPayment"
        )[0]?.config?.minPercentage;

        val > 0 && setPartialPercentage(val);
      }
    }
  }, [payments]);

  useEffect(() => {
    if (policies?.length > 0) {
      let temp =
        policies?.filter((pol) => pol?.type === "cancellation_policy") || [];

      if (temp?.length > 0) {
        temp[0]?.HotelPolicies?.sort(
          (a, b) =>
            b?.variables?.daysBeforeArrival - a?.variables?.daysBeforeArrival
        );

        setCancellationPolicy(temp[0]?.HotelPolicies);
      }
    }
  }, [policies]);

  useEffect(() => {
    let last, diffDays;
    if (cancellationPolicy?.length > 0) {
      if (cancellationPolicy[0]?.variables?.chargedPercentage === 0) {
        last = dayjs(dateRange?.startDate).subtract(
          cancellationPolicy[0]?.variables?.daysBeforeArrival,
          "day"
        );
      } else {
        last = dayjs(dateRange?.startDate).subtract(
          cancellationPolicy[0]?.variables?.daysBeforeArrival + 1,
          "day"
        );
      }
      diffDays = last?.diff(dayjs(), "day");
      if (diffDays >= 0) {
        setShowCancel(true);
      }
      setLastDate(last?.format("MMM DD"));
    } else {
      diffDays = dayjs(dateRange?.startDate).diff(dayjs(), "day");

      if (diffDays >= 1) {
        last = dayjs(dateRange?.startDate).subtract(1, "day");
        setShowCancel(true);
        setLastDate(last?.format("MMM DD"));
      }
    }
  }, [cancellationPolicy, room?.pricing]);

  useEffect(() => {
    if (selectedAddons?.length > 0) {
      setExtraAdult(
        selectedAddons?.filter(
          (addon) =>
            addon?.Addon?.name === "Extra Adult" &&
            addon?.hotelRoomId === room?.id
        )?.length
      );
      setExtraChild(
        selectedAddons?.filter(
          (addon) =>
            addon?.Addon?.name === "Extra Child" &&
            addon?.type === "child" &&
            addon?.hotelRoomId === room?.id
        )?.length
      );
      setExtraInfant(
        selectedAddons?.filter(
          (addon) =>
            addon?.Addon?.name === "Extra Child" &&
            addon?.type === "infant" &&
            addon?.hotelRoomId === room?.id
        )?.length
      );
      setDinner(
        selectedAddons?.filter(
          (addon) =>
            addon?.Addon?.name === "Dinner" && addon?.hotelRoomId === room?.id
        )?.length
      );
      setLunch(
        selectedAddons?.filter(
          (addon) =>
            addon?.Addon?.name === "Lunch" && addon?.hotelRoomId === room?.id
        )?.length
      );
      setBreakfast(
        selectedAddons?.filter(
          (addon) =>
            addon?.Addon?.name === "Breakfast" &&
            addon?.hotelRoomId === room?.id
        )?.length
      );
    }
  }, [selectedAddons]);

  useEffect(() => {
    let guestCount = selectedAddons?.filter(
      (adn) =>
        adn?.hotel_room_id === room?.id && adn?.Addon?.category === "person"
    )?.length;
    if (guestToDisplay && guestToDisplay === defaultGuestCount + guestCount) {
      setExtraAdult(0);
      setExtraChild(0);
    }
  }, [extraAdult, extraChild]);

  useEffect(() => {
    let finalPrice = 0;
    let val = totalAdult <= maxGuestCount ? totalAdult : maxGuestCount;

    if (
      priceConfigDifference &&
      Object.keys(priceConfigDifference).length > 0
    ) {
      pricing.forEach((pr) => {
        finalPrice =
          finalPrice +
          parseFloat(pr?.price) +
          parseFloat(priceConfigDifference[val]);
      });
    } else {
      pricing.forEach((pr) => {
        finalPrice =
          finalPrice +
          parseFloat(pr.price) * (parseFloat(priceConfig[val]) || 1);
      });
    }
    let tempPrice = pricing?.length === 0 ? defaultPrice : finalPrice;
    if (hotelData?.userId === 63809) {
      tempPrice = tempPrice > 8400 ? tempPrice / 1.18 : tempPrice / 1.12;
    }
    setPrice(tempPrice);
    setPeople(parseInt(defaultGuestCount));

    if (totalAdult <= maxGuestCount) {
      setPriceToDisplay(tempPrice);
      setGuestToDisplay(totalAdult);
    } else {
      setPriceToDisplay(null);
      setGuestToDisplay(maxGuestCount);
    }

    if (updatedRoomCount[room?.id] >= 0) {
      setAvailableRooms(updatedRoomCount[room?.id]);
    } else {
      setAvailableRooms(aRooms);
    }
  }, [totalAdult, room, extraPrice, aRooms, updatedRoomCount]);

  useEffect(() => {
    if (isDorm && maxGuestCount !== defaultGuestCount && availableRooms > 0) {
      setAvailableRooms(1);
    }
  }, [isDorm, room, aRooms]);

  useEffect(() => {
    let width = windowSize.width > 901 ? 300 : 400;

    setSize(width);
  }, [windowSize]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const handleImage = (id) => {
    setViewImage(true);
    setCurrentIndex(id);
  };

  useEffect(() => {
    if (selectedRooms?.length === 0) {
      dispatch({ type: hotelInfoTypes.SET_SLOTS, payload: {} });
    }
  }, [selectedRooms?.length]);

  // NEW TYPE

  const testId = storageService.get("testId") || 0;

  useEffect(() => {
    const {
      priceConfig = {},
      defaultGuestCount,
      maxGuestCount,
      HotelRoomAddons,
      pricing,
      extraChildPrice,
      childAgeSplit,
      extraInfantPrice,
    } = room;
    let guests = Object.keys(priceConfig).map(Number);
    let additionalGuestCount = guests.length - defaultGuestCount;
    let averagePrice = 0;
    pricing.forEach((pr) => {
      averagePrice += parseFloat(pr.price);
    });
    averagePrice = averagePrice / pricing?.length;
    let newAddons = [];
    let childAddons = [];
    if (maxGuestCount > defaultGuestCount) {
      for (let i = 1; i <= additionalGuestCount; i++) {
        let addonPrice =
          (priceConfig[defaultGuestCount + i] -
            priceConfig[defaultGuestCount + i - 1]) *
          averagePrice;
        let newAddonObj = {
          hotelRoomId: room?.id,
          hotel_room_id: room?.id,
          price: addonPrice.toFixed(getFixedValue(hotelData?.currency)),
          Addon: {
            name: "Extra Adult",
            displayName: t("extra_adult"),
            category: "person",
          },
        };
        newAddons.push(newAddonObj);
      }
      if (extraChildPrice) {
        let obj = {
          hotelRoomId: room?.id,
          hotel_room_id: room?.id,
          price: parseFloat(extraChildPrice).toFixed(
            getFixedValue(hotelData?.currency)
          ),
          type: "child",
          Addon: {
            name: "Extra Child",
            displayName: childAgeSplit
              ? `${t("extra_child")} (${childAgeSplit}-18`
              : `${t("extra_child")} (12-18)`,
            category: "person",
          },
        };
        childAddons.push(obj);
      }
      if (extraInfantPrice) {
        let obj = {
          hotelRoomId: room?.id,
          hotel_room_id: room?.id,
          price: parseFloat(extraInfantPrice).toFixed(
            getFixedValue(hotelData?.currency)
          ),
          type: "infant",
          Addon: {
            name: "Extra Child",
            displayName: childAgeSplit
              ? `${t("extra_child")} (0-${childAgeSplit})`
              : `${t("extra_child")} (0-12)`,
            category: "person",
          },
        };
        childAddons.push(obj);
      }
    }
    let newroom = [...HotelRoomAddons, newAddons[0] || []];
    // newAddons?.sort((a, b) => b?.price - a?.price);
    setAddons([...newroom, ...childAddons]);
    setAdultAddons(newAddons);
    setCompareAdultAddons(newAddons);
  }, [selectedRooms, room]);

  useEffect(() => {
    if (roomCount > 1) {
      let arr = [...adultAddons, ...compareAdultAddons];
      setAdultAddons(arr);
    }
  }, [roomCount]);

  // useEffect(() => {
  //   const calculateVisibleItems = () => {
  //     return;
  //     const items = truncatedLines || [];
  //     console.log(items);
  //     const container = descriptionRef.current;
  //     console.log("hi");
  //     if (!container || !items?.length) return;
  //     console.log("hello");

  //     // Create a temporary list to measure
  //     const temp = document.createElement("ul");
  //     temp.style.cssText = window.getComputedStyle(
  //       container.firstChild
  //     ).cssText;
  //     temp.style.position = "absolute";
  //     temp.style.visibility = "hidden";
  //     temp.style.height = "auto";
  //     temp.style.width = `${container.clientWidth}px`;
  //     document.body.appendChild(temp);

  //     // Binary search to find the maximum number of visible items
  //     let start = 0;
  //     let end = items.length;
  //     let visibleCount = 0;

  //     while (start <= end) {
  //       const mid = Math.floor((start + end) / 2);
  //       temp.innerHTML =
  //         items
  //           .slice(0, mid)
  //           .map((item) => `<li>${item}</li>`)
  //           .join("") + "<li>...</li>";

  //       if (temp.offsetHeight <= container.clientHeight) {
  //         visibleCount = mid;
  //         start = mid + 1;
  //       } else {
  //         end = mid - 1;
  //       }
  //     }

  //     // Clean up
  //     document.body.removeChild(temp);

  //     // Update state
  //     setVisibleItems(items.slice(0, visibleCount));
  //     setShowEllipsis(visibleCount < items.length);
  //   };

  //   // Calculate initially
  //   calculateVisibleItems();

  //   // Recalculate on resize
  //   const resizeObserver = new ResizeObserver(calculateVisibleItems);
  //   resizeObserver.observe(descriptionRef?.current);

  //   return () => {
  //     resizeObserver.disconnect();
  //   };
  // }, [truncatedLines?.truncatedLines]);

  useEffect(() => {
    const calculateVisibleItems = () => {
      // Your original logic remains unchanged
      const items = truncatedLines || [];
      const container = descriptionRef.current;
      if (!container || !items?.length) return;

      // Create a temporary list to measure
      const temp = document.createElement("ul");
      temp.style.cssText = window.getComputedStyle(
        container.firstChild
      ).cssText;
      temp.style.position = "absolute";
      temp.style.visibility = "hidden";
      temp.style.height = "auto";
      temp.style.width = `${container.clientWidth}px`;
      document.body.appendChild(temp);

      // Binary search to find the maximum number of visible items
      let start = 0;
      let end = items.length;
      let visibleCount = 0;

      while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        temp.innerHTML =
          items
            .slice(0, mid)
            .map((item) => `<li>${item}</li>`)
            .join("") + "<li>...</li>";

        if (temp.offsetHeight <= container.clientHeight) {
          visibleCount = mid;
          start = mid + 1;
        } else {
          end = mid - 1;
        }
      }

      // Clean up
      document.body.removeChild(temp);

      // Update state
      setVisibleItems(items.slice(0, visibleCount));
      setShowEllipsis(visibleCount < items.length);
    };

    if (descriptionRef.current) {
      // Ensure descriptionRef.current exists before observing
      const resizeObserver = new ResizeObserver(calculateVisibleItems);
      resizeObserver.observe(descriptionRef.current);

      // Cleanup on unmount
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [truncatedLines?.truncatedLines]);

  const handleSelectedSlots = (slot, isDisable) => {
    if (isDisable) {
      return;
    }
    fireGtmEvent("slot_selected", { slot });
    dispatch({
      type: hotelInfoTypes.SET_SLOTS,
      payload: {},
    });
    let obj = {};
    const { HotelRooms = [] } = hotelData;

    let filterRooms =
      HotelRooms?.filter((rms) =>
        rms?.hourly?.some((hr) => hr?.hour === slot?.hour)
      ) || [];

    let removeRooms = [];
    filterRooms.forEach((rms) => {
      const { hourly = [] } = rms;
      if (hourly?.length > 0) {
        var newobj = {};
        let arr = hourly?.filter((hr) => hr?.hour === slot?.hour) || [];
        if (arr?.length > 0) {
          newobj = arr[0];
        }
        if (arr?.length > 0) {
          removeRooms = [
            ...removeRooms,
            ...selectedRooms
              ?.filter((rem) => rem?.id === rms?.id)
              ?.map((rm) => rm?.id),
          ];
          obj = { ...obj, [newobj?.roomId]: newobj };
        }
      }
    });
    if (Object.keys(obj).length > 0) {
      let arr = [...selectedRooms];
      arr.forEach((rm) => {
        if (!removeRooms.includes(rm?.id))
          dispatch({ type: hotelInfoTypes.DESELECT_ROOM, payload: rm });
      });
      dispatch({
        type: hotelInfoTypes.SET_SLOTS,
        payload: obj,
      });
      if (roomCount === 0 && selectedRooms?.length === 0) {
        if (testId === 0) {
          let adultC =
            totalAdult <= room?.maxGuestCount ? totalAdult : maxGuestCount;
          dispatch({
            type: hotelInfoTypes.SELECT_ROOM,
            payload: {
              idx: 1,
              sAdult: adultC,
              sChild: 0,
              sInfant: 0,
              ...room,
            },
          });
        } else {
          dispatch({
            type: hotelInfoTypes.SET_ROOM,
            payload: room,
          });
        }
        // remove stuff
        // change above payload to room from { idx: 1, sAdult: 2, sChild: 0, sInfant: 0, ...room }
        // end remove stuff
      }
      dispatch({
        type: hotelInfoTypes.SET_HOUR,
        payload: slot?.hour,
      });
    }
  };

  const changeRoomCount = (e) => {
    let temp = Number(e.target.value);
    fireGtmEvent("room_added", {
      selectedRooomCount: temp,
      room,
    });

    if (hotelData?.userId === 103376 && window && window?.gtag) {
      window?.gtag("event", "add_to_cart", {
        value: price,
        currency: hotelData?.currency,
        items: [
          {
            price: price, // Room price per night
            item_id: hotelData?.id, // Room ID or SKU
            item_name: room?.roomName, // Room name
          },
        ],
      });
    }

    let userHistory = JSON.parse(localStorage.getItem("userHistory")) || {};
    let historyObj = {
      id: hotelData?.id,
      checkInDate: dayjs(dateRange?.startDate).format("YYYY-MM-DD"),
      checkOutDate: dayjs(dateRange?.endDate).format("YYYY-MM-DD"),
      currenDate: dayjs().format("YYYY-MM-DD HH:mm"),
      event: "room_added",
    };
    let tempHistory = userHistory[hotelData?.id] || [];
    userHistory = {
      ...userHistory,
      [hotelData?.id]: [...tempHistory, historyObj],
    };
    localStorage.setItem("userHistory", JSON.stringify(userHistory));

    let isHighCalled = storageService.get("newHighEventCalled") || false;
    if (!isHighCalled) {
      pixelHighIntent("potential_guest");
      storageService.set("newHighEventCalled", true);
    }
    setSelectedRoomCount(temp);

    if (temp >= 0) {
      dispatch({
        type: hotelInfoTypes.RESET_ROOM,
        payload: { id: room?.id, resetAdn: false },
      });
      if (window) {
        window?.gtag("event", "add_to_cart", {
          value: room?.pricing?.[0]?.price * temp,
          items: [
            {
              id: id,
              start_date: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
              end_date: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
              google_business_vertical: "hotel_rental",
            },
          ],
        });
      }
      let adult =
        totalAdult + totalChild <= maxGuestCount ? totalAdult : maxGuestCount;
      let child =
        room?.extraChildPrice && totalAdult + totalChild <= maxGuestCount
          ? totalChild
          : 0;
      for (let i = 0; i < temp; i++) {
        let obj = {
          idx: i + 1,
          sAdult: adult,
          sChild: child,
          sInfant: 0,
          ...room,
        };
        dispatch(addRoom(obj));
        addRoomAds();
      }
    } else if (temp < 0 && roomCount > 0) {
      dispatch({
        type: hotelInfoTypes.RESET_ROOM,
        payload: { id: room?.id, resetAdn: true },
      });
      fireGtmEvent("room_removed", {
        room,
      });
      if (hotelData?.userId === 103376 && window && window?.gtag) {
        window?.gtag("event", "remove_from_cart", {
          value: price,
          currency: hotelData?.currency,
          items: [
            {
              price: price, // Room price per night
              item_id: hotelData?.id, // Room ID or SKU
              item_name: room?.roomName, // Room name
            },
          ],
        });
      }
    }
  };

  // RATE PLANS EDITION

  useEffect(() => {
    if (isRatePlans && room?.availableRooms) {
      setRPRoomCount(room?.availableRooms || 0);
    } else {
      setRPRoomCount(0);
    }
  }, [room?.id]);

  const rpTypes = useMemo(() => {
    if (!isRatePlans) return [];
    return pricing
      ?.filter(
        (obj, index, self) =>
          index ===
          self.findIndex((t) => t["ratePlanCode"] === obj["ratePlanCode"])
      )
      ?.map((tp) => tp?.ratePlanCode);
  }, [pricing]);

  useEffect(() => {
    if (promotions?.length > 0) {
      let ar = arrangePromos(promotions);
      setArrangedPromos(ar);
    } else {
      setArrangedPromos([]);
    }
  }, [promotions, hotelData?.id]);

  const { rmPrice, rmTax, rmPriceReduced, noDiscPrice, basePrice } =
    useMemo(() => {
      let tempAdult =
          totalAdult <= room?.maxGuestCount ? totalAdult : room?.maxGuestCount,
        tempChild = 0,
        tempPrice = 0,
        priceReduced = 0,
        tempTax = 0,
        noDiscPrice = 0,
        promosApplied = [];
      let defaultPrice = 0;
      let isDiffConfig = chosenPriceConfig === "priceConfigDifference";
      const priceForAll = calculateRooms();
      if (priceForAll.length > 0) {
        setSearchGuestCount(totalAdult + totalChild);
        setSearchRoomCount(priceForAll.length);
        setUseSearchData(true);
        setSearchData(priceForAll);

        priceForAll.forEach((pfa) => {
          tempAdult = pfa.adults;
          tempChild = pfa.children;
          pricing.forEach((pr, idx) => {
            let sum = 0,
              prVal = 0;

            if (isDiffConfig && room?.priceConfigDifference) {
              sum += pr?.price + parseFloat(priceConfigDifference[tempAdult]);
            } else {
              sum += pr?.price * parseFloat(priceConfig[tempAdult]);
            }

            // if (tempInfant && tempInfant > 0) {
            //   sum += room?.extraInfantPrice * tempInfant;
            // }

            if (tempChild && tempChild > 0) {
              sum += room?.extraChildPrice * tempChild;
            }
            noDiscPrice += sum;
            const promo = getApplicablePromotionRoom({
              arrangedPromos: promotions,
              rp: { roomId: room?.id },
              tempPrice: sum,
              checkInDate: pr?.date,
            });

            if (promo) {
              promosApplied.push(promo);
            }
            let { finalValue, reducedPrice } = calculatePromotion({
              price: sum,
              promo,
              idx,
              dateCount,
            });

            priceReduced += reducedPrice;

            const taxObj = getCalculatedTax({
              taxes: taxes,
              rooms: [{ id: room?.id, amount: finalValue }],
              isInclusive: hotelData?.isTaxIncluded,
              noOfNights: 1,
            });
            tempPrice +=
              finalValue + (hotelData?.isTaxIncluded ? taxObj.totalRoomTax : 0);
            tempTax += Math.abs(taxObj.totalRoomTax);

            if (isHourlyRoom) {
              let slotObj = roomSlots[room?.id];
              let defaultPrice = 0;
              if (isDiffConfig && priceConfigDifference) {
                defaultPrice =
                  Number(pr?.price) +
                  parseFloat(priceConfigDifference[room?.defaultGuestCount]);
              } else {
                defaultPrice =
                  Number(pr?.price) *
                  parseFloat(priceConfig[room?.defaultGuestCount]);
              }

              if (tempAdult <= room?.defaultGuestCount) {
                tempPrice = defaultPrice * slotObj?.percentage;
              } else {
                if (isDiffConfig && priceConfigDifference) {
                  tempPrice =
                    defaultPrice * slotObj?.percentage +
                    priceConfigDifference[room?.sAdult];
                } else {
                  tempPrice =
                    defaultPrice * slotObj?.percentage +
                    (priceConfig[room?.sAdult] * defaultPrice - defaultPrice);
                }
              }
              priceReduced = 0;
              tempTax = 0;
            }
          });
        });
      } else {
        setSearchData([]);
        setSearchGuestCount(tempAdult);
        setSearchRoomCount(1);
        setUseSearchData(false);
        pricing.forEach((pr, idx) => {
          let sum = 0,
            prVal = 0;

          if (isDiffConfig && priceConfigDifference) {
            sum += pr?.price + parseFloat(priceConfigDifference[tempAdult]);
          } else {
            sum += pr?.price * parseFloat(priceConfig[tempAdult]);
          }
          noDiscPrice += sum;
          const promo = getApplicablePromotionRoom({
            arrangedPromos: promotions,
            rp: { roomId: room?.id },
            tempPrice: sum,
            checkInDate: pr?.date,
          });

          if (promo) {
            promosApplied.push(promo);
          }
          let { finalValue, reducedPrice } = calculatePromotion({
            price: sum,
            promo,
            idx,
            dateCount,
          });

          priceReduced += reducedPrice;

          const taxObj = getCalculatedTax({
            taxes: taxes,
            rooms: [{ id: room?.id, amount: finalValue }],
            isInclusive: hotelData?.isTaxIncluded,
            noOfNights: 1,
          });
          tempPrice +=
            finalValue + (hotelData?.isTaxIncluded ? taxObj.totalRoomTax : 0);
          tempTax += Math.abs(taxObj.totalRoomTax);

          if (isHourlyRoom) {
            if (isDiffConfig && priceConfigDifference) {
              defaultPrice =
                Number(pr?.price) +
                parseFloat(priceConfigDifference[room?.defaultGuestCount]);
            } else {
              defaultPrice =
                Number(pr?.price) *
                parseFloat(priceConfig[room?.defaultGuestCount]);
            }

            // if (tempAdult <= room?.defaultGuestCount) {
            //   tempPrice = defaultPrice;
            // } else {
            //   if (isDiffConfig && priceConfigDifference) {
            //     tempPrice = defaultPrice + priceConfigDifference[tempAdult];
            //   } else {
            //     tempPrice =
            //       defaultPrice +
            //       priceConfig[tempAdult] * defaultPrice -
            //       defaultPrice;
            //   }
            // }
            priceReduced = 0;
            tempTax = 0;
          }
        });
      }

      if (room?.availableRooms && !isRatePlans) {
        const lowestPrice = storageService.get("lowestPrice") ?? Infinity;
        storageService.set(
          "lowestPrice",
          Math.min(lowestPrice, tempPrice * extraPrice + tempTax * extraPrice)
        );
      }

      return {
        rmPrice: Number(tempPrice * extraPrice),
        rmTax: Number(tempTax * extraPrice),
        rmPriceReduced: Number(priceReduced * extraPrice),
        noDiscPrice: Number(noDiscPrice * extraPrice),
        basePrice: defaultPrice,
      };
    }, [pricing, arrangedPromos, isHourlyRoom, dateRange]);

  function calculateRooms() {
    let rooms = [];
    let remainingAdults = totalAdult;
    let remainingChildren = totalChild;

    if ((totalChild > 0 && !room?.extraChildPrice) || isHourlyRoom) {
      return [];
    }

    for (let i = 0; i < availableRooms; i++) {
      if (remainingAdults === 0 && remainingChildren === 0) break;

      let currentRoom = {
        adults: 0,
        children: 0,
        infants: 0,
      };

      // Ensure at least one adult in the room
      if (remainingAdults > 0) {
        currentRoom.adults = 1;
        remainingAdults -= 1;
      } else {
        break; // No more adults to place with children
      }

      // Fill the remaining space in the room with children first
      let remainingSpace = maxGuestCount - currentRoom.adults;
      if (remainingChildren > 0) {
        if (remainingChildren >= remainingSpace) {
          currentRoom.children = remainingSpace;
          remainingChildren -= remainingSpace;
        } else {
          currentRoom.children = remainingChildren;
          remainingChildren = 0;
        }
      }

      // Fill any remaining space with adults
      remainingSpace =
        maxGuestCount - (currentRoom.adults + currentRoom.children);
      if (remainingSpace > 0 && remainingAdults > 0) {
        if (remainingAdults >= remainingSpace) {
          currentRoom.adults += remainingSpace;
          remainingAdults -= remainingSpace;
        } else {
          currentRoom.adults += remainingAdults;
          remainingAdults = 0;
        }
      }

      rooms.push(currentRoom);
    }

    // Check if all guests are accommodated
    if (remainingAdults > 0 || remainingChildren > 0) {
      return [];
    }

    return rooms;
  }

  const addSearchData = () => {
    if (searchData.length <= 0) {
      return;
    }
    const checkInDate = dayjs(dateRange?.startDate);
    const checkOutDate = dayjs(dateRange?.endDate);
    const nightDifference = checkOutDate.diff(checkInDate, "day");
    // console.log("dt", dateRange, nightDifference, hotelData?.minBookingNights);

    if (
      hotelData?.minBookingNights &&
      nightDifference < hotelData.minBookingNights
    ) {
      toastr.error(
        `Minimum booking nights required: ${hotelData.minBookingNights}`
      );
      return;
    }
    for (let i = 0; i < searchData.length; i++) {
      let obj = {
        idx: i + 1,
        sAdult: searchData[i]?.adults,
        sChild: searchData[i]?.children,
        sInfant: searchData[i]?.infants,
        ...room,
      };
      dispatch(addRoom(obj));
      addRoomAds();
    }
    fireGtmEvent("searchRoom_added", { searchData, room });
  };

  const addRoomAds = () => {
    if (window) {
      window?.gtag("event", "conversion", {
        send_to: "AW-10960259904/_RXWCJnb3MwZEMCWoeoo",
        value: rmPrice + rmTax,
        currency: hotelData?.currency,
        event_callback: () => {},
      });
    }
  };

  const shouldShowButton =
    isTruncated || room?.description?.split("\n").length > 2;

  useEffect(() => {
    const num = Math.floor(Math.random() * 6) + 45;
    setpercentageguests(num);
  }, []);

  // console.log({ hi: room.ratePlans });

  return (
    <div className="room" id={`room-${room.id}`}>
      <div
        className={
          availableRooms === 0 || room?.pricing?.length === 0
            ? "room__container disableRoom"
            : "room__container"
        }
      >
        <div
          className="room__topContainer"
          // style={{ minWidth: `${size}px`, minHeight: `${size}px` }}
        >
          {RoomImages?.length === 0 ? (
            <img
              className="room__topLeftContainer"
              src={`https://ik.imagekit.io/hotelzifyprod/logo.png?tr=w-auto-${size},ar-1-1,h-auto-350,q-${IMAGE_QUALITY}`}
              alt="room img"
              height={"350px"}
              style={{ objectFit: "contain", maxWidth: "100%" }}
              width={size + "px"}
              loading="lazy"
              onClick={() => RoomImages[0]?.cdnImageUrl && setViewImage(true)}
            />
          ) : (
            <Carousel
              infiniteLoop
              showStatus={!viewImage}
              showThumbs={false}
              preventMovementUntilSwipeScrollTolerance
              showArrows={!viewImage}
              showIndicators={false}
              // autoPlay
              onClickItem={(id) => {
                handleImage(id);
                fireGtmEvent("room_image_expanded");
              }}
              className="room__topLeftContainer"
            >
              {RoomImages?.map((image, id) => (
                <img
                  key={id}
                  width={size}
                  height={"300px"}
                  loading={id === 0 ? "eager" : "lazy"}
                  className="room__image"
                  src={
                    image?.cdnImageUrl +
                    `?tr=w-${size},h-300,q-${IMAGE_QUALITY},fo-auto`
                  }
                  // src={image.cdnImageUrl + "?tr=w-720,h-600,cm-pad_resize,bg-000000"}
                  srcSet=""
                  alt={`${roomName} Room Image of ${hotelData?.name}`}
                  title={roomName}
                />
              ))}
            </Carousel>
          )}
        </div>
        <div
          className="roomNewContainer"
          style={{
            maxHeight: "500px",
            minHeight: "fit-content",
          }}
        >
          {room?.availableRooms > 0 && (
            <div style={notificationDivStyle}>
              <p>
                {notifications?.some(
                  (notification) =>
                    notification &&
                    typeof notification === "object" &&
                    Object.keys(notification).length > 0 &&
                    Object.keys(notification)[0] === room?.roomName
                ) &&
                  getRoomNotification(
                    notifications,
                    room,
                    peopleViewing,
                    bookedMinutesAgo,
                    randomNumber,
                    hotelData
                  )}
              </p>
            </div>
          )}
          <div
            className="room__topRightContainer"
            style={{
              // overflow: "hidden",
              height: "fit-content",
              minHeight: 0,
              maxHeight: "250px",
              flexGrow: 1,
              marginTop: windowSize.width <= 900 ? "0px" : "5px",
            }}
          >
            <div className="roomName">
              <h2>{roomName}</h2>

              {!isModify && isFirst && availableRooms > 0 && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <p
                    className="recommended"
                    onMouseEnter={() => setTooltipVisible(true)}
                    onMouseLeave={() => setTooltipVisible(false)}
                    style={{ cursor: "pointer" }}
                  >
                    {hotelData?.HotelRooms?.length === 1
                      ? t(getTextKey(hotelData?.userId, "lowest_price_ever"))
                      : t("recommended")}
                  </p>

                  {isTooltipVisible ? (
                    <div
                      style={{
                        visibility: isTooltipVisible ? "visible" : "hidden",
                        position: "absolute",
                        top: "100%",
                        right: windowSize?.width > 900 ? "20px" : "0px",
                        marginTop: "8px",
                        backgroundColor: "#333",
                        color: "#fff",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        fontSize: windowSize?.width > 500 ? "14px" : "12px",
                        zIndex: 1000,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        width: "max-content",
                        maxWidth: "90vw",
                        whiteSpace: "normal",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "-6px",
                          // left: "10px",
                          right: "10px",
                          transform: "translateX(-50%)",
                          width: 0,
                          height: 0,
                          borderLeft: "6px solid transparent",
                          borderRight: "6px solid transparent",
                          borderBottom: "6px solid #333", // arrow pointing up
                        }}
                      />
                      <p style={{ margin: 0 }}>
                        Over {percentageguests ? percentageguests : "30"}% of
                        our guests recommend our {room?.roomName}
                        {typeof room?.roomName === "string" &&
                        room?.roomName?.toLowerCase()?.includes("room")
                          ? ""
                          : " Room"}
                      </p>
                    </div>
                  ) : null}
                </div>
              )}
              {isSelected && <p className="recommended">Current Selection</p>}
            </div>
            {room?.description && (
              <div
                style={{
                  width: "100%",
                  // flexGrow: 1,
                  overflow: "hidden",
                  position: "relative",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  // maxHeight: "150px",
                }}
                ref={descriptionRef}
              >
                {isOverflowing ? (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: 0,
                      right: 0,
                      height: "60px",
                      background: "linear-gradient(transparent, white)",
                    }}
                  />
                ) : null}
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  {truncatedLines.map((line, index) => (
                    <li key={index}>{line}</li>
                  ))}
                </ul>
                {isOverflowing && (
                  <div
                    style={{
                      background: "white",
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: "30px",
                    }}
                  >
                    <button
                      onClick={() => setRoomDescOpen(!isRoomDescOpen)}
                      className="text-blue-500 ml-2"
                      style={{
                        background: "none",
                        fontWeight: "800",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {isRoomDescOpen ? "Close" : "View More"}
                    </button>
                  </div>
                )}
              </div>
            )}
            <Drawer
              isOpen={isRoomDescOpen}
              setIsOpen={setRoomDescOpen}
              // width="700px"
              // height="500px"
              overflow="hidden"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  maxHeight: "500px",
                }}
              >
                <div
                  style={{
                    position: "sticky",
                    top: 0,
                    left: 0,
                    right: 0,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: "5px 10px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                  }}
                >
                  <h2 className="uppercase">{t("Description")}</h2>

                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      alt="close modal"
                      src="https://ik.imagekit.io/hotelzifyprod/cross_rgYPtv6N7.svg"
                      width={20}
                      height={20}
                      onClick={() => setRoomDescOpen(!isRoomDescOpen)}
                    />
                  </div>
                </div>

                <div
                  style={{
                    padding: "20px",
                    overflowY: "auto",
                    flexGrow: 1,
                    // height: "calc(100% - 60px)",
                  }}
                >
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    {room?.description?.split("\n").map((line, index) => (
                      <li
                        key={index}
                        style={{
                          marginBottom: "10px",
                          wordBreak: "break-word", // Add this line
                          overflowWrap: "break-word",
                        }}
                      >
                        {line.trim()}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Drawer>
            <div className="roomInfo">
              <div className="room_texts">
                {!isRatePlans && searchData.length === 0 ? (
                  guestToDisplay ? (
                    <p>
                      <Icon
                        iconName={
                          <img
                            src={userpic}
                            width="25px"
                            alt="userpic"
                            height="100%"
                          />
                        }
                        tooltip={t("min_pax")}
                      />{" "}
                      {t("price_for_upto")} {guestToDisplay}{" "}
                      {isDorm ? t("bed") : t("guests")}
                    </p>
                  ) : (
                    <p>
                      <Icon
                        iconName={
                          <img
                            src={userpic}
                            width="25px"
                            alt="userpic"
                            height="100%"
                          />
                        }
                        tooltip={t("min_pax")}
                      />{" "}
                      {t("price_for")}
                      {defaultGuestCount === 1 ? " " : ` ${t("upto")}`}{" "}
                      {defaultGuestCount} {isDorm ? t("bed") : t("guests")}
                    </p>
                  )
                ) : null}
                {isDorm ? (
                  <p>
                    <Icon
                      iconName={
                        <img
                          src={roomBunkImg}
                          alt="room bunk bed"
                          height="100%"
                          width={"25px"}
                        />
                      }
                      tooltip={t("max_bed")}
                    />
                    {aRooms} {t("bed_dorm")}
                  </p>
                ) : maxGuestCount - defaultGuestCount > 0 && !guestToDisplay ? (
                  <p>
                    <Icon
                      iconName={
                        <img
                          src={userpic}
                          alt="userpic"
                          width={"25px"}
                          height="100%"
                        />
                      }
                      tooltip={t("max_pax")}
                    />
                    {t("max")} {maxGuestCount - defaultGuestCount}{" "}
                    {t("additional_guests")}
                  </p>
                ) : (
                  <></>
                )}
                {!isRatePlans && (
                  <div className="freeRoomStuff">
                    {freeFood?.map((food, id) => {
                      return (
                        <p
                          style={{ color: "#1A7971", fontWeight: "bold" }}
                          key={id}
                        >
                          {" "}
                          <Icon
                            iconName={
                              <img
                                src={foodPic}
                                alt="userpic"
                                height="100%"
                                width={"25px"}
                              />
                            }
                            tooltip={t("free")}
                          />{" "}
                          {food?.Addon?.name} {t("included")}
                        </p>
                      );
                    })}

                    {freeGuest?.map((food, id) => {
                      return (
                        <p
                          style={{ color: "#1A7971", fontWeight: "bold" }}
                          key={id}
                        >
                          {" "}
                          <Icon
                            iconName={
                              <img
                                src={check}
                                alt="userpic"
                                height="100%"
                                width={"25px"}
                              />
                            }
                            tooltip={t("verified")}
                          />{" "}
                          {food?.Addon?.name} {t("can_stay_for_free")}
                        </p>
                      );
                    })}

                    {showCancel && !isRatePlans && (
                      <p style={{ color: "#1A7971", fontWeight: "bold" }}>
                        {" "}
                        <Icon
                          iconName={
                            <img
                              src={check}
                              alt="userpic"
                              height="100%"
                              width={"25px"}
                            />
                          }
                          tooltip="Verified"
                        />{" "}
                        {t("free_cancellation_till")} {lastDates}
                      </p>
                    )}
                    {isCOD && (
                      <p style={{ color: "#1A7971", fontWeight: "bold" }}>
                        {" "}
                        <Icon
                          iconName={
                            <img
                              src={check}
                              alt="userpic"
                              height="100%"
                              width={"25px"}
                            />
                          }
                          tooltip={t("verified")}
                        />{" "}
                        {t("book_now_pay_later")}
                      </p>
                    )}
                    {partialPercentage && !isCOD && (
                      <p style={{ color: "#1A7971", fontWeight: "bold" }}>
                        {" "}
                        <Icon
                          iconName={
                            <img
                              src={check}
                              alt="userpic"
                              height="100%"
                              width={"25px"}
                            />
                          }
                          tooltip={t("verified")}
                        />{" "}
                        {t("reserve_at_just")} {currencies(hotelData?.currency)}
                        {((partialPercentage / 100) * price).toFixed(
                          getFixedValue(hotelData?.currency)
                        )}
                        !
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="roomAmenityContainer">
            {HotelRoomAmenities?.map((am, id) => {
              return (
                <p key={id}>
                  <Icon
                    iconName={RoomAmenityIcons[am?.Amenity?.name]}
                    tooltip={am?.Amenity?.name}
                    style={{ fontSize: "12px" }}
                  />
                  {am?.Amenity?.Trasalations?.[0]?.name || am?.Amenity?.name}
                </p>
              );
            })}
          </div>
          {availableRooms === 0 ||
          (isRatePlans && !room?.ratePlans) ||
          room?.pricing?.length === 0 ? (
            <div className="soldOutNotifyBox">
              <div className="soldOut">{t("sold_out")}</div>
              <button
                className={
                  hoverNotify ? "getNotifiedButtonHover" : "getNotifiedButton"
                }
                onMouseEnter={() => setHoverNotify(true)}
                onMouseLeave={() => setHoverNotify(false)}
                onClick={() => setShowRetargModal(true)}
              >
                <MdNotificationsActive size={24} />
                Get Notified
              </button>
            </div>
          ) : (
            availableRooms < 3 && (
              <div className="soldOut">
                {availableRooms + " " + t("room_left_hurry_up")}
              </div>
            )
          )}
          {/* <div className="roomCount">
            {isModify && availableRooms === 0 ? (
              <div>
                <p>
                  {t("you_have_selected")} {t("rooms")}
                </p>
              </div>
            ) : (
              <div className="hAddonAdded">
                <img
                  src={minus}
                  alt="remove room"
                  className="hAddonIcon"
                  onClick={decrement}
                />

                <span>{value}</span>
                <img
                  src={plus}
                  alt="add room"
                  className="hAddonIcon"
                  onClick={increment}
                />
              </div>
            )}
          </div> */}
          {isHourlyRoom && availableRooms !== 0 && (
            <div className="room__hourlyContainer">
              {hourly?.map((slot) => {
                let isDisable = !(
                  isStartTimeBeforeEndTime(
                    convert24hrTo12hr(slot?.firstCheckInTime),
                    hourlyTime
                  ) &&
                  isStartTimeBeforeEndTime(
                    hourlyTime,
                    convert24hrTo12hr(slot?.lastCheckInTime)
                  )
                );

                let isDiffConfig =
                  chosenPriceConfig === "priceConfigDifference";
                let tempAdult =
                  totalAdult <= maxGuestCount ? totalAdult : maxGuestCount;
                let isTemp = totalAdult <= defaultGuestCount;

                return (
                  <div
                    className={`roomSlot ${
                      roomSlots[room?.id]?.id === slot?.id && "selectedSlot"
                    } ${isDisable && "slotDisable"} `}
                    onClick={() => handleSelectedSlots(slot, isDisable)}
                    key={slot?.id}
                  >
                    <span>
                      {currencies(hotelData?.currency)}{" "}
                      {isTemp
                        ? (basePrice * Number(slot?.percentage)).toFixed(
                            getFixedValue(hotelData?.currency)
                          )
                        : isDiffConfig && priceConfigDifference
                        ? (
                            basePrice * slot?.percentage +
                            priceConfigDifference[tempAdult]
                          ).toFixed(getFixedValue(hotelData?.currency))
                        : (
                            basePrice * slot?.percentage +
                            (priceConfig[tempAdult] * basePrice - basePrice)
                          ).toFixed(getFixedValue(hotelData?.currency))}
                    </span>

                    <p>
                      {slot?.hour} {t("hour")}
                    </p>
                  </div>
                );
              })}
            </div>
          )}
          {/* Secret Member Deal */}
          {!isRatePlans &&
            secretMemberDetails?.name &&
            secretMemberDetails?.description &&
            isSecretMemberUnlocked && (
              <div
                className="secretMemberTitleBox"
                style={{ padding: "0px 20px" }}
              >
                <h3>{secretMemberDetails?.name}</h3>
                <div className="secretMemberVerticalLine"></div>
                <p>{secretMemberDetails?.description}</p>
              </div>
            )}
          <div className="room__midContainer">
            {!isRatePlans && (
              <div className="priceSection">
                <div className="discountedPriceContainer">
                  {availableRooms !== 0 && rmPriceReduced > 0 && (
                    <>
                      {rmPriceReduced > 0 && (
                        <b>
                          <span className="discountedPrice">
                            {/* {(
                              noDiscPrice -
                              (!hotelData?.isTaxIncluded ? 0 : rmTax)
                            ).toFixed(getFixedValue(hotelData?.currency))}{" "} */}
                            {(
                              (Number(noDiscPrice) || 0) -
                              (!hotelData?.isTaxIncluded
                                ? 0
                                : Number(rmTax) || 0) /
                                Math.max(dateCount, 1)
                            ).toFixed(getFixedValue(hotelData?.currency))}
                          </span>{" "}
                          <span
                            className="discountedPrice"
                            style={{
                              textDecoration: "none",
                              color: "var(--green)",
                            }}
                          >
                            {" "}
                            {currencies(hotelData?.currency)}{" "}
                            {rmPriceReduced.toFixed(
                              getFixedValue(hotelData?.currency)
                            )}{" "}
                            {t("off")}
                          </span>
                        </b>
                      )}
                    </>
                  )}
                </div>
                {/* FAKE PRICE */}
                {promotions?.length < 1 && storageService.get("subscribed") && (
                  <div
                    className="discountedPriceContainer"
                    style={{ marginTop: "10px" }}
                  >
                    <b>
                      <span className="discountedPrice">
                        {currencies(hotelData?.currency)}
                      </span>
                    </b>
                    <b>
                      <span className="discountedPrice">
                        {(rmPrice * 1.15 * extraPrice).toFixed(
                          getFixedValue(hotelData?.currency)
                        )}
                      </span>
                    </b>
                  </div>
                )}
                {availableRooms > 0 && !isHourlyRoom && !isRatePlans && (
                  <div className="roomTaxPrice">
                    <p>
                      <b>
                        {currencies(hotelData?.currency)}{" "}
                        {rmPrice.toFixed(getFixedValue(hotelData?.currency))}{" "}
                      </b>
                      {/* <span>
                        <b>/ {t("night")}</b>
                      </span> */}
                      {/* </p> */}

                      {/* <p> */}
                      <b>
                        <span>/ {dateCount > 1 ? dateCount : null}</span>{" "}
                        <span>{t(pluralWords(dateCount, "night"))}</span>
                      </b>
                    </p>

                    {rmTax > 0 ? (
                      <p>
                        <span>{t("Plus")} </span>

                        {/* {currencies(hotelData?.currency)}{" "}
                        {rmTax?.toFixed(getFixedValue(hotelData?.currency))}{" "} */}
                        {""}
                        {t("taxes")}
                      </p>
                    ) : (
                      t("incl_of_taxes")
                    )}
                    {searchData.length >= 1 && (
                      <p style={{ color: "#000", fontSize: "0.9rem" }}>
                        {searchGuestCount}{" "}
                        {t(pluralWords(searchGuestCount, "guest"))}{" "}
                        {searchRoomCount}{" "}
                        {t(
                          pluralWords(searchRoomCount, isDorm ? "bed" : "room")
                        )}
                      </p>
                    )}
                    {isVRHotel ? (
                      <span style={{ maxWidth: "220px" }}>
                        (This room can accommodate up to {maxGuestCount || 1}{" "}
                        guests)
                      </span>
                    ) : null}
                  </div>
                )}
              </div>
            )}

            {!isHourlyRoom && !isRatePlans && !isModify && (
              <Link
                className="viewMore"
                to={{
                  pathname: "/room-view/" + id,
                  state: {
                    room,
                  },
                }}
              >
                <p>{t("view_room")}</p>
              </Link>
            )}
            {availableRooms !== 0 && !isRatePlans && (
              <>
                {(!isHourlyRoom || selectedRooms?.length > 0) &&
                  (testId === 0 ? (
                    searchData.length > 0 &&
                    !isHourlyRoom &&
                    !selectedRooms?.some((rm) => rm?.id === room?.id) ? (
                      <button
                        onClick={addSearchData}
                        className="hAddonAdd btnShadow"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                          padding: "10px 0",
                          width: "max-content",
                          fontSize: "1rem",
                        }}
                      >
                        {/* {t("select")} {isDorm ? t("bed") : t("room")} */}
                        {console.log("key", hotelData?.HotelType?.name)}
                        {t("select")}{" "}
                        {isDorm
                          ? t("bed")
                          : shouldUseHotelType(hotelData?.userId)
                          ? hotelData?.HotelType?.name
                          : t("room")}
                      </button>
                    ) : (
                      <>
                        <label
                          htmlFor={`rmSelect${room?.id}`}
                          style={{
                            color: "#fff",
                            position: "absolute",
                            zIndex: "-1",
                          }}
                        >
                          {t("select_rooms")}
                        </label>
                        <select
                          id={`rmSelect${room?.id}`}
                          value={roomCount}
                          className="roomSelectDropdown"
                          style={{
                            background: roomCount > 0 && "#fff",
                            color:
                              roomCount > 0
                                ? mmtColorHotels.includes(hotelData?.id)
                                  ? "var(--primary-color)"
                                  : "var(--blue)"
                                : "#fff",
                            fontWeight: roomCount > 0 && "bold",
                          }}
                          onChange={changeRoomCount}
                        >
                          <option value={-1}>
                            {t("select")}{" "}
                            {isDorm
                              ? t("bed")
                              : shouldUseHotelType(hotelData?.userId)
                              ? hotelData?.HotelType?.name
                              : t("room")}
                          </option>
                          {Array.from({ length: availableRooms }).map(
                            (_, id) => (
                              <option key={id} value={id + 1}>
                                {id + 1}{" "}
                                {id + 1 === 1
                                  ? isDorm
                                    ? t("bed")
                                    : shouldUseHotelType(hotelData?.userId)
                                    ? hotelData?.HotelType?.name
                                    : t("room")
                                  : isDorm
                                  ? t("Beds")
                                  : shouldUseHotelType(hotelData?.userId)
                                  ? `${hotelData?.HotelType?.name}s`
                                  : t("rooms")}
                              </option>
                            )
                          )}
                        </select>
                      </>
                    )
                  ) : (
                    <Button
                      value={roomCount}
                      setValue={setRoomCount}
                      maxValue={availableRooms}
                      room={room}
                      price={price}
                      isHourlyRoom={isHourlyRoom}
                    />
                  ))}
              </>
            )}
          </div>
          {!isRatePlans && availableRooms > 0 && (
            <SecretMemberDeal
              price={rmPrice.toFixed(getFixedValue(hotelData?.currency))}
              getMembershipDetails={(name, description) =>
                setSecretMemberDetails({ name, description })
              }
              getSecretMemberDealUrl={getSecretMemberDealUrl}
              applyPromotion={applyPromotion}
              promotionRes={promotionRes}
            />
          )}
          {isHourlyRoom && roomCount > 0 && (
            <div
              style={{
                width: "100%",
                padding: "0 20px",
                textAlign: "right",
                fontSize: "0.8rem",
                color: "green",
              }}
            >
              {roomCount}{" "}
              {roomCount > 1
                ? isDorm
                  ? t("Beds")
                  : t("rooms")
                : isDorm
                ? t("bed")
                : t("room")}{" "}
              {t("selected")}
            </div>
          )}
        </div>
      </div>
      <div
        className="room__bottomContainer"
        style={{
          flexDirection: "column",
          padding: "0 10px",
        }}
      >
        {isRatePlans &&
          availableRooms > 0 &&
          room?.ratePlans &&
          Object.values(room?.ratePlans ?? {})
            ?.sort((a, b) => {
              const priceA = a?.prices?.priceAfterDiscount || Number.MAX_VALUE;
              const priceB = b?.prices?.priceAfterDiscount || Number.MAX_VALUE;
              return priceA - priceB;
            })
            .map((rateplan, id) => (
              <RatePlanContainer
                key={id}
                idx={id}
                setAvailableRooms={setAvailableRooms}
                maxRoomPerBooking={hotelData?.maxRoomPerBooking}
                rpRoomCount={rpRoomCount}
                availableRooms={availableRooms}
                setRPRoomCount={setRPRoomCount}
                selectedRPRoomCount={selectedRPRoomCount}
                setSelectedRPRoomCount={setSelectedRPRoomCount}
                room={room}
                extraPrice={extraPrice}
                code={rateplan?.ratePlanCode}
                rateplan={rateplan}
                notificationStyle={notificationStyle}
                handleRoomPrice={handleRoomPrice}
                pricingfornotifications={pricingfornotifications}
                getSecretMemberDealUrl={getSecretMemberDealUrl}
                applyPromotion={applyPromotion}
                promotionRes={promotionRes}
              />
            ))}
      </div>
      {!isDorm && testId === 0 && (
        <div
          className="room__bottomContainer"
          style={{ borderBottom: "none", borderRadius: "0px" }}
        >
          <div className="newSelectionContainer">
            {Array.from({ length: roomCount }).map((_, id) => {
              return (
                <NewSelectionSlot
                  id={id + 1}
                  defaultGuestCount={defaultGuestCount}
                  maxGuestCount={maxGuestCount}
                  key={id}
                  childAgeSplit={room?.childAgeSplit || 12}
                  childAgeLimit={room?.childAgeLimit || 18}
                  extraChildPrice={room?.extraChildPrice}
                  extraInfantPrice={room?.extraInfantPrice}
                  room={room}
                />
              );
            })}
          </div>
        </div>
      )}
      <div
        className="room__bottomContainer"
        style={{ borderRadius: roomCount === 0 && "8px" }}
      >
        {
          <div
            className="room__amenities"
            style={{
              borderTop:
                testId === 0 &&
                addons?.some((ad) => ad?.Addon?.category === "meal") &&
                "1px solid #dadada",
              borderRadius: testId === 0 && "0 0 8px 8px",
            }}
          >
            {addons?.map((addon, id) => {
              let customAddonName = addon?.Addon?.name;

              return (
                <div key={id} className="room__addons">
                  {roomCount > 0 && addon.price !== "0.00" ? (
                    addon?.Addon?.category === "person" ? (
                      totalPeople > defaultGuestCount &&
                      defaultGuestCount < maxGuestCount &&
                      testId !== 0 && (
                        <div className="room__addon peopleAddon">
                          <AddonButton
                            name={addon?.Addon?.name}
                            extraChild={extraChild}
                            setExtraChild={setExtraChild}
                            extraAdult={extraAdult}
                            setExtraAdult={setExtraAdult}
                            room={room}
                            maxGuestCount={maxGuestCount}
                            addon={addon}
                            setPeople={setPeople}
                            defaultGuestCount={defaultGuestCount}
                            totalPeople={totalPeople}
                            guestToDisplay={guestToDisplay}
                            roomCount={roomCount}
                            adultAddons={adultAddons}
                            extraInfant={extraInfant}
                            setExtraInfant={setExtraInfant}
                          />{" "}
                          <div className="addonRearrange">
                            <b>
                              {addon?.Addon?.name === "Extra Adult" ? (
                                <img src={userpic} alt="user" width={24} />
                              ) : (
                                <img src={kidPic} alt="user" width={20} />
                              )}{" "}
                              {t("add")}{" "}
                              {addon?.Addon?.displayName || addon?.Addon?.name}{" "}
                            </b>{" "}
                            <p>
                              ({currencies(hotelData?.currency)}{" "}
                              {addon?.Addon?.name === "Extra Adult"
                                ? adultAddons[extraAdult]?.price ||
                                  adultAddons[adultAddons?.length - 1]?.price
                                : addon?.price}
                              / {t("room")} / {t("day")}) ({t("incl_of_taxes")})
                            </p>
                          </div>
                        </div>
                      )
                    ) : addon?.Addon?.category === "meal" ? (
                      <div className="room__addon peopleAddon">
                        <MealAddon
                          room={room}
                          name={addon?.Addon?.name}
                          addon={addon}
                          breakfast={breakfast}
                          lunch={lunch}
                          dinner={dinner}
                          setBreakfast={setBreakfast}
                          setLunch={setLunch}
                          setDinner={setDinner}
                          addAddon={addAddon}
                          deselectAddon={deselectAddon}
                          maxGuestCount={
                            maxGuestCount *
                            selectedRooms?.filter((rm) => rm?.id === room?.id)
                              ?.length
                          }
                        />
                        <div className="addonRearrange">
                          <b>
                            <img src={foodPic} alt="food" width={20} />{" "}
                            {customAddonName}{" "}
                          </b>
                          <p>
                            ( {currencies(hotelData?.currency)} {addon?.price} /
                            {t("person")} / {t("day")}) ({t("incl_of_taxes")})
                          </p>
                        </div>
                      </div>
                    ) : null
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          </div>
        }
      </div>
      {!storageService.get("subscribed") &&
        !sourceTest.includes(storageService.get("source")) &&
        !window.location.href.includes("/rooms/") &&
        showFakePrice &&
        availableRooms > 0 && (
          <div className="splPriceUnlock offerBar">
            <p className="offerbarTxt">{t("unlock_additional_discount")}</p>
            <button
              className="offerBarBtn"
              onClick={() => {
                fireGtmEvent("subscribe_popup_shown", { position: "room" });
                showLoyal(true);
              }}
              style={{ fontSize: "0.8rem" }}
            >
              {t("unlock")} 🔓
            </button>
          </div>
        )}
      {viewImage && (
        <ImageViewer
          // src={RoomImages?.map(
          //   (img) => img?.cdnImageUrl //+ `?tr=w-${size},h-300,q-${IMAGE_QUALITY},fo-auto`
          //   // return `${img.cdnImageUrl}?tr=w-${size},ar-1-1,q-${IMAGE_QUALITY}`;
          // )}
          src={RoomImages?.map(
            (img) =>
              `${img?.cdnImageUrl}?tr=w-1000,fo-contain,q-${IMAGE_QUALITY}`
          )}
          currentIndex={currentIndex}
          disableScroll={false}
          closeOnClickOutside={true}
          onClose={setViewImage}
        />
      )}
      {showRetargModal && (
        <InventoryRetargModal
          onClose={() => setShowRetargModal(false)}
          dateRange={dateRange}
          adults={adults}
          child={child}
        />
      )}
    </div>
  );
};

export default Room;
